(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Per-bar AbortController so re-init (Theme Editor section reload) cleans up
  // document-level listeners deterministically. Without this, every
  // shopify:section:load attached another visibilitychange listener whose closure
  // pinned the now-detached bar element — slow, observable editor leak.
  function initBar(bar) {
    if (!bar || bar.dataset.serenAnnInit === '1') return;
    bar.dataset.serenAnnInit = '1';

    var controller = new AbortController();
    bar._serenAnnController = controller;

    if (bar.hasAttribute('data-dismissable')) {
      var key = bar.getAttribute('data-dismiss-key');
      if (key) {
        try {
          if (sessionStorage.getItem(key) === '1') {
            bar.style.display = 'none';
            return;
          }
        } catch (e) {
          // sessionStorage blocked (private mode) — render the bar anyway
        }

        var btn = bar.querySelector('[data-announcement-dismiss]');
        if (btn) {
          btn.hidden = false; // Reveal once JS has wired the click handler
          btn.addEventListener('click', function () {
            bar.style.display = 'none';
            try { sessionStorage.setItem(key, '1'); } catch (e) { /* ignore */ }
          }, { signal: controller.signal });
        }
      }
    }

    initRotation(bar, controller.signal);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) bar.classList.add('is-paused');
      else bar.classList.remove('is-paused');
    }, { signal: controller.signal });
  }

  // Rotation is pure CSS (one keyframe track per slide, staggered delays), so
  // each slide's animationstart / animationiteration marks the moment it takes
  // over. Expose that slide and hide the rest (aria-hidden + inert). A slide
  // that still holds keyboard focus stays exposed until focus leaves it.
  function initRotation(bar, signal) {
    var viewport = bar.querySelector('.announcement-bar__viewport');
    if (!viewport) return;
    var slides = Array.prototype.slice.call(viewport.querySelectorAll('.announcement-bar__slide'));
    if (slides.length < 2) return;
    var current = slides[0];

    function show(slide) {
      current = slide;
      slides.forEach(function (s) {
        var on = s === slide;
        if (!on && s.contains(document.activeElement)) return;
        s.inert = !on;
        if (on) s.removeAttribute('aria-hidden');
        else s.setAttribute('aria-hidden', 'true');
      });
    }

    function onSlideAnimation(e) {
      if (e.target.classList && e.target.classList.contains('announcement-bar__slide')) show(e.target);
    }

    viewport.addEventListener('animationstart', onSlideAnimation, { signal: signal });
    viewport.addEventListener('animationiteration', onSlideAnimation, { signal: signal });
    viewport.addEventListener('focusout', function (e) {
      // Focus moving between links of the same slide keeps it exposed.
      var from = e.target.closest && e.target.closest('.announcement-bar__slide');
      if (from && e.relatedTarget && from.contains(e.relatedTarget)) return;
      show(current);
    }, { signal: signal });
  }

  function init() {
    document.querySelectorAll('[data-announcement-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme Editor: tear down the old bar's listeners before Shopify swaps in the new DOM.
  document.addEventListener('shopify:section:unload', function (e) {
    var bar = e.target.querySelector('[data-announcement-bar]');
    if (bar && bar._serenAnnController) bar._serenAnnController.abort();
  });

  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector('[data-announcement-bar]');
    if (bar) initBar(bar);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    var url = btn.getAttribute('data-copy-link');
    if (!url || !navigator.clipboard) return;
    navigator.clipboard.writeText(url).then(function () {
      var orig = btn.innerHTML;
      btn.textContent = window.t('article_link_copied', 'Copied');
      window.setTimeout(function () {
        btn.innerHTML = orig;
      }, 2000);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Comparator: update clip-path + divider position from range input. */
  function applyCompare(input) {
    var compare = input.closest('[data-ba-compare]');
    if (!compare) return;
    var top = compare.querySelector('[data-ba-top]');
    var divider = compare.querySelector('[data-ba-divider]');
    var v = Number(input.value);
    if (Number.isNaN(v)) v = 50;
    if (v < 0) v = 0;
    if (v > 100) v = 100;
    if (top) top.style.clipPath = 'inset(0 0 0 ' + v + '%)';
    if (divider) divider.style.left = v + '%';
  }

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-ba-range]')) applyCompare(t);
  });

  function initCompares(scope) {
    (scope || document).querySelectorAll('[data-ba-range]').forEach(applyCompare);
  }

  /* Slideshow: scroll-snap carousel with prev/next + dots. */
  function initSlideshow(root) {
    if (root.getAttribute('data-ba-slideshow-init') === 'true') return;
    root.setAttribute('data-ba-slideshow-init', 'true');
    var slides = root.querySelector('[data-ba-slides]');
    if (!slides) return;
    var prev = root.querySelector('[data-ba-prev]');
    var next = root.querySelector('[data-ba-next]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ba-dot]'));

    /* JS smooth scrolling ignores the CSS reduced-motion kill, so ask first. */
    function scrollBehavior() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth';
    }

    function step(delta) {
      slides.scrollBy({ left: delta * slides.clientWidth, behavior: scrollBehavior() });
    }

    function currentIndex() {
      var w = slides.clientWidth || 1;
      return Math.round(slides.scrollLeft / w);
    }

    function syncDots() {
      var idx = currentIndex();
      dots.forEach(function (d, i) {
        if (i === idx) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = Number(d.getAttribute('data-ba-dot-index')) || 0;
        slides.scrollTo({ left: i * slides.clientWidth, behavior: scrollBehavior() });
      });
    });

    var rafId = 0;
    slides.addEventListener('scroll', function () {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = 0;
        syncDots();
      });
    });
    syncDots();
  }

  /* Marquee: desktop hover/focus already pause via CSS. For touch we flip an
     `.is-interacting` class while the user is dragging a slider inside a tile, and
     clear it on pointerup so the rail resumes once they release / move away.

     Per-root init only attaches the pointerdown listener to the root (GC'd with the
     root on section replace). The document-level pointerup/cancel listeners are
     registered once at IIFE start so editor section replaces don't leak. */
  var marqueeResumeTimers = new WeakMap();

  function marqueeScheduleResume(root) {
    window.clearTimeout(marqueeResumeTimers.get(root));
    var t = window.setTimeout(function () {
      root.classList.remove('is-interacting');
      var active = document.activeElement;
      if (active && active.matches && active.matches('.ba__range') && root.contains(active)) {
        active.blur();
      }
    }, 400);
    marqueeResumeTimers.set(root, t);
  }

  function initMarquee(root) {
    if (root.getAttribute('data-ba-marquee-init') === 'true') return;
    root.setAttribute('data-ba-marquee-init', 'true');

    root.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest('[data-ba-range]')) {
        window.clearTimeout(marqueeResumeTimers.get(root));
        root.classList.add('is-interacting');
      }
    });
  }

  function releaseAllMarquees() {
    document.querySelectorAll('[data-ba-marquee].is-interacting').forEach(marqueeScheduleResume);
  }
  document.addEventListener('pointerup', releaseAllMarquees);
  document.addEventListener('pointercancel', releaseAllMarquees);

  function initAll(scope) {
    initCompares(scope);
    (scope || document).querySelectorAll('[data-ba-slideshow]').forEach(initSlideshow);
    (scope || document).querySelectorAll('[data-ba-marquee]').forEach(initMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /** Sub-pixel tolerance; matches collection-showcase tablist scroll hints. */
  var SCROLL_EDGE_EPS = 2;

  function bindBlogTaglistHints(wrap) {
    if (!wrap || wrap.getAttribute('data-blog-taglist-hint-bound') === 'true') return;
    var list = wrap.querySelector('.tablist');
    if (!list) return;
    wrap.setAttribute('data-blog-taglist-hint-bound', 'true');

    function updateHints() {
      var maxScrollPx = list.scrollWidth - list.clientWidth;
      if (maxScrollPx < SCROLL_EDGE_EPS) {
        wrap.classList.remove('is-scrollable', 'is-at-start', 'is-at-end');
        return;
      }
      wrap.classList.add('is-scrollable');
      var sl = list.scrollLeft;
      wrap.classList.toggle('is-at-start', sl <= SCROLL_EDGE_EPS);
      wrap.classList.toggle('is-at-end', sl >= maxScrollPx - SCROLL_EDGE_EPS);
    }

    list.addEventListener('scroll', updateHints, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      var roHint = new ResizeObserver(updateHints);
      roHint.observe(list);
    } else {
      window.addEventListener('resize', updateHints);
    }
    updateHints();
  }

  function initBlogTaglists(ctx) {
    var scope = ctx && ctx.querySelectorAll ? ctx : document;
    var wraps = scope.querySelectorAll('[data-blog-taglist-wrap]');
    wraps.forEach(bindBlogTaglistHints);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBlogTaglists();
    });
  } else {
    initBlogTaglists();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelectorAll) {
      initBlogTaglists(ev.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  'use strict';

  var noteTimer = null;

  function lineKeyFromChild(el) {
    var wrap = el && el.closest('[data-cart-line-key]');
    return wrap ? wrap.getAttribute('data-cart-line-key') : null;
  }

  function parseQtyInputValue(input) {
    var raw = input.value.trim();
    if (raw === '') return null;
    var v = parseInt(raw, 10);
    if (isNaN(v)) return null;
    if (v < 0) v = 0;
    if (v > 999) v = 999;
    return v;
  }

  function commitCartDrawerQtyInput(input) {
    if (!input || !window.SerenCart || !input.closest('[data-cart-drawer]')) return;
    var wrap = input.closest('[data-cart-line-key]');
    if (!wrap) return;
    var key = wrap.getAttribute('data-cart-line-key');
    if (!key) return;
    var parsed = parseQtyInputValue(input);
    if (parsed === null) {
      var last = input.getAttribute('data-committed-qty');
      input.value = last != null && last !== '' ? last : '1';
      return;
    }
    input.value = String(parsed);
    var committed = parseInt(input.getAttribute('data-committed-qty'), 10);
    if (isNaN(committed)) committed = 0;
    if (parsed === committed) return;
    input.setAttribute('data-committed-qty', String(parsed));
    setLineLoading(input, true);
    var p = parsed === 0
      ? window.SerenCart.removeItem(key)
      : window.SerenCart.updateQuantity(key, parsed);
    p.catch(function () {
      setLineLoading(input, false);
      showCartError();
    });
  }

  function showCartError() {
    if (window.SerenToast) window.SerenToast.cartUpdateError();
  }

  function setLineLoading(el, loading) {
    var row = el && el.closest('[data-cart-line-key]');
    if (row) {
      row.classList.toggle('is-loading', loading);
      row.style.opacity = loading ? '0.5' : '';
      row.style.pointerEvents = loading ? 'none' : '';
    }
  }

  document.addEventListener('click', function (e) {
    var rem = e.target.closest('[data-cart-line-remove]');
    if (rem && rem.closest('[data-cart-drawer]')) {
      e.preventDefault();
      e.stopPropagation();
      var key = lineKeyFromChild(rem);
      if (key && window.SerenCart) {
        setLineLoading(rem, true);
        window.SerenCart.removeItem(key).catch(function () {
          setLineLoading(rem, false);
          showCartError();
        });
      }
      return;
    }

    var dec = e.target.closest('[data-cart-qty-dec]');
    if (dec && dec.closest('[data-cart-drawer]')) {
      e.preventDefault();
      e.stopPropagation();
      if (window.SerenCart) window.SerenCart.stepLineQuantity(dec, -1);
      return;
    }

    var inc = e.target.closest('[data-cart-qty-inc]');
    if (inc && inc.closest('[data-cart-drawer]')) {
      e.preventDefault();
      e.stopPropagation();
      if (window.SerenCart) window.SerenCart.stepLineQuantity(inc, 1);
      return;
    }

    var upsell = e.target.closest('[data-cart-upsell-add]');
    if (upsell && upsell.closest('[data-cart-drawer]')) {
      e.preventDefault();
      e.stopPropagation();
      var vid = upsell.getAttribute('data-cart-upsell-add');
      if (vid && window.SerenCart) {
        var addItem = { id: parseInt(vid, 10), quantity: 1 };
        upsell.classList.add('is-loading');
        upsell.setAttribute('aria-busy', 'true');
        // Smooth removal: fade the slide while the add + drawer section refresh
        // run. The added product de-dups out of the re-rendered drawer, so it
        // would otherwise vanish instantly. Gated by prefers-reduced-motion (CSS).
        var slide = upsell.closest('.cart-drawer__upsell-slide');
        if (slide) slide.classList.add('is-removing');
        window.SerenCart.addItems([addItem]).catch(function () {
          if (slide) slide.classList.remove('is-removing');
          showCartError();
        }).finally(function () {
          upsell.classList.remove('is-loading');
          upsell.removeAttribute('aria-busy');
        });
      }
    }
  });

  document.addEventListener(
    'input',
    function (e) {
      var ta = e.target.closest('[data-cart-note]');
      if (!ta || !window.SerenCart) return;
      var val = ta.value;
      if (noteTimer) window.clearTimeout(noteTimer);
      noteTimer = window.setTimeout(function () {
        window.SerenCart.updateNote(val);
      }, 500);
    },
    false
  );

  document.addEventListener(
    'change',
    function (e) {
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input || !input.closest('[data-cart-drawer]')) return;
      commitCartDrawerQtyInput(input);
    },
    false
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('[data-cart-qty-input]');
      if (!input || !input.closest('[data-cart-drawer]')) return;
      e.preventDefault();
      commitCartDrawerQtyInput(input);
      input.blur();
    },
    false
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  // Force a cart-discount re-eval on page load. Same reasoning as the
  // cart drawer's openDrawer hook — Shopify caches discount allocations
  // on the cart, so a discount removed in admin (archived bundle, etc.)
  // would otherwise show stale on this page until the customer modifies
  // the cart. window.refreshCartDiscounts is exposed by theme.js and
  // already short-circuits on empty carts internally.
  function maybeRefreshDiscounts() {
    if (typeof window.refreshCartDiscounts === 'function') {
      window.refreshCartDiscounts();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeRefreshDiscounts);
  } else {
    maybeRefreshDiscounts();
  }

  function inCartPage(el) {
    return !!(el && el.closest('[data-cart]'));
  }

  function lineKeyFromChild(el) {
    var wrap = el && el.closest('[data-cart-line-key]');
    return wrap ? wrap.getAttribute('data-cart-line-key') : null;
  }

  function parseQtyInputValue(input) {
    var raw = input.value.trim();
    if (raw === '') return null;
    var v = parseInt(raw, 10);
    if (isNaN(v)) return null;
    if (v < 0) v = 0;
    if (v > 999) v = 999;
    return v;
  }

  function showCartError() {
    if (window.SerenToast) window.SerenToast.cartUpdateError();
  }

  function setLineLoading(el, loading) {
    var row = el && el.closest('[data-cart-line-key]');
    if (row) {
      row.style.opacity = loading ? '0.5' : '';
      row.style.pointerEvents = loading ? 'none' : '';
    }
  }

  function commitQtyInput(input) {
    if (!input || !window.SerenCart || !inCartPage(input)) return;
    var wrap = input.closest('[data-cart-line-key]');
    if (!wrap) return;
    var key = wrap.getAttribute('data-cart-line-key');
    if (!key) return;
    var parsed = parseQtyInputValue(input);
    if (parsed === null) {
      var last = input.getAttribute('data-committed-qty');
      input.value = last != null && last !== '' ? last : '1';
      return;
    }
    input.value = String(parsed);
    var committed = parseInt(input.getAttribute('data-committed-qty'), 10);
    if (isNaN(committed)) committed = 0;
    if (parsed === committed) return;
    input.setAttribute('data-committed-qty', String(parsed));
    setLineLoading(input, true);
    var p = parsed === 0
      ? window.SerenCart.removeItem(key)
      : window.SerenCart.updateQuantity(key, parsed);
    p.catch(function () {
      setLineLoading(input, false);
      showCartError();
    });
  }

  document.addEventListener('click', function (e) {
    var rem = e.target.closest('[data-cart-line-remove]');
    if (rem && inCartPage(rem)) {
      e.preventDefault();
      e.stopPropagation();
      var key = lineKeyFromChild(rem);
      if (key && window.SerenCart) {
        setLineLoading(rem, true);
        window.SerenCart.removeItem(key).catch(function () {
          setLineLoading(rem, false);
          showCartError();
        });
      }
      return;
    }

    var dec = e.target.closest('[data-cart-qty-dec]');
    if (dec && inCartPage(dec)) {
      e.preventDefault();
      e.stopPropagation();
      if (window.SerenCart) window.SerenCart.stepLineQuantity(dec, -1);
      return;
    }

    var inc = e.target.closest('[data-cart-qty-inc]');
    if (inc && inCartPage(inc)) {
      e.preventDefault();
      e.stopPropagation();
      if (window.SerenCart) window.SerenCart.stepLineQuantity(inc, 1);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input || !inCartPage(input)) return;
    commitQtyInput(input);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-cart-qty-input]');
    if (!input || !inCartPage(input)) return;
    e.preventDefault();
    commitQtyInput(input);
  });

  var noteTimer = null;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note || !inCartPage(note)) return;
    if (!window.SerenCart || typeof window.SerenCart.updateNote !== 'function') return;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(function () {
      window.SerenCart.updateNote(note.value);
    }, 600);
  });

  /* Sticky bar visibility — observes the summary's primary checkout
     button. When it scrolls out of view, `.is-visible` is added and the
     bar slides up. The bar element ITSELF persists across cart-section
     refreshes (rendered outside `[data-cart-section-refresh]`), so the
     bar's class state survives DOM swaps — only the observer's TARGET
     (the checkout button inside the refreshable wrapper) is replaced
     and needs rebinding.

     Two timing defenses:
     1. Setup is deferred to `window.load` (or rAF if already loaded) so
        the first IntersectionObserver fire happens AFTER layout settles
        — during initial paint the desktop summary's `position: sticky`
        hasn't engaged, line-item images haven't loaded, etc., causing
        the button to briefly read as out-of-view. Observer only fires
        on STATE CHANGES, so a wrong "not intersecting" first fire
        sticks until the state actually flips.
     2. `rootMargin: '0px 0px 16px 0px'` extends the observer's "in-view"
        zone 16px below the viewport bottom — small layout jitter during
        load won't flip the intersection state. */
  function bindStickyBar() {
    var stickyBar = document.querySelector('[data-cart-sticky-bar]');
    var checkoutBtn = document.querySelector('[data-cart-checkout]');
    if (!stickyBar || !checkoutBtn || !('IntersectionObserver' in window)) return;
    if (stickyBar.__serenStickyObserver) stickyBar.__serenStickyObserver.disconnect();
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== checkoutBtn) return;
          var hidden = !entry.isIntersecting;
          stickyBar.classList.toggle('is-visible', hidden);
          stickyBar.setAttribute('aria-hidden', hidden ? 'false' : 'true');
          // inert (+ visibility in section-cart.css) keeps the hidden bar's
          // checkout link out of the tab order.
          if (hidden) stickyBar.removeAttribute('inert');
          else stickyBar.setAttribute('inert', '');
        });
      },
      { threshold: 0, rootMargin: '0px 0px 16px 0px' }
    );
    obs.observe(checkoutBtn);
    stickyBar.__serenStickyObserver = obs;
  }

  function scheduleStickyBarBind() {
    if (document.readyState === 'complete') {
      window.requestAnimationFrame(bindStickyBar);
    } else {
      window.addEventListener('load', function onLoad() {
        window.removeEventListener('load', onLoad);
        window.requestAnimationFrame(bindStickyBar);
      });
    }
  }

  /* Update the persistent bar's total + savings using the cart object
     from the `theme:cart:updated` detail. Mirrors the Liquid savings
     calculation: prefer line-level (compare_at_price - final_price) ×
     qty when on sale; fall back to (original_line_price - final_line_price)
     for cart-discount allocations. Falls back gracefully when SerenTheme
     formatter isn't loaded yet. */
  function computeCartSavingsCents(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      var qty = item.quantity || 1;
      var compareAt = item.compare_at_price;
      var finalPrice = item.final_price || 0;
      if (compareAt && compareAt > finalPrice) {
        return sum + (compareAt - finalPrice) * qty;
      }
      var lineDisc = (item.original_line_price || 0) - (item.final_line_price || 0);
      return sum + (lineDisc > 0 ? lineDisc : 0);
    }, 0);
  }

  function formatMoneyCentsLocal(cents) {
    /* `SerenTheme.formatMoneyCents` is defined early in `theme.js`
       (before this section's static JS block evaluates), so availability
       is guaranteed in practice. If the assumption ever breaks,
       returning the empty string is safer than a USD-shaped fallback
       that would silently lie about the currency on non-USD stores. */
    if (window.SerenTheme && typeof window.SerenTheme.formatMoneyCents === 'function') {
      return window.SerenTheme.formatMoneyCents(cents);
    }
    return '';
  }

  function updateCartStickyContent(cart) {
    var bar = document.querySelector('[data-cart-sticky-bar]');
    if (!bar || !cart) return;

    /* Show / hide the bar based on cart contents. The bar is rendered
       unconditionally so it can appear on cart-drawer-driven additions
       too; without this, removing the last line item would leave the
       bar showing "$0.00" beside the empty-state message. The footer's
       reserved padding is gated on `:not([hidden])` so it tracks
       visibility automatically. */
    var hasItems = typeof cart.item_count === 'number' && cart.item_count > 0;
    if (hasItems) {
      bar.removeAttribute('hidden');
    } else {
      bar.setAttribute('hidden', '');
    }

    var totalEl = bar.querySelector('[data-cart-sticky-value]');
    if (totalEl && typeof cart.total_price === 'number') {
      totalEl.textContent = formatMoneyCentsLocal(cart.total_price);
    }
    var savedEl = bar.querySelector('[data-cart-sticky-saved]');
    if (savedEl) {
      var savings = computeCartSavingsCents(cart);
      if (savings > 0) {
        var tpl = bar.getAttribute('data-saved-template') || '';
        savedEl.textContent = tpl.split('__SEREN_AMOUNT__').join(formatMoneyCentsLocal(savings));
        savedEl.removeAttribute('hidden');
      } else {
        savedEl.textContent = '';
        savedEl.setAttribute('hidden', '');
      }
    }
  }

  scheduleStickyBarBind();

  /* On cart updates: refresh bar content from the event payload, then
     re-bind the observer (the checkout button inside the refreshable
     wrapper has been replaced, so the existing observer's target is
     stale). rAF defers past the same-tick innerHTML swap. */
  document.addEventListener('theme:cart:updated', function (ev) {
    if (ev && ev.detail && ev.detail.cart) {
      updateCartStickyContent(ev.detail.cart);
    }
    window.requestAnimationFrame(bindStickyBar);
  });

  /* Theme editor section reload — Shopify dispatches
     `shopify:section:load` when a merchant edits cart settings in the
     editor and the section's HTML is replaced. The bar's attribute
     state is fresh from the new render, but the observer's target
     reference is stale. Rebind so merchants previewing settings see
     correct behavior. Quality-of-life only; not a customer path. */
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target || !ev.target.querySelector) return;
    if (!ev.target.querySelector('[data-cart-section-refresh]')) return;
    window.requestAnimationFrame(bindStickyBar);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-stories"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* One controller per `[data-community-stories]` root. Each root owns
     its own data island, its own viewer DOM, and its own playback
     state — multi-instance pages don't need a global registry.

     Items[] is a flat array: each entry is one story (name, avatar,
     time, media). The viewer shows N progress bars at the top (one per
     item), auto-advances through the queue, and loops at the end. */

  function init(root) {
    if (!root || root.__csInit) return;
    root.__csInit = true;

    var dataEl = root.querySelector('[data-cs-data]');
    var viewer = root.querySelector('[data-cs-viewer]');
    if (!dataEl || !viewer) return;

    /* Lazy-parse the data island on the first click rather than at
       init. Two benefits:
       1. If the JSON is malformed we still bind click handlers, so
          retries and recovery are possible (vs an early return that
          silently disables the whole section).
       2. Zero parse cost for users who never open the viewer. */
    var items = null;
    function getItems() {
      if (items !== null) return items;
      var parsed;
      try { parsed = JSON.parse(dataEl.textContent) || []; }
      catch (e) { parsed = []; }
      items = parsed.filter(function (item) { return item && item.src; });
      return items;
    }

    var imageDuration = parseInt(root.getAttribute('data-cs-image-duration'), 10) || 5000;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    /* State */
    var currentIndex = 0;
    var slideTimer = null;
    var paused = false;
    var prevFocus = null;

    /* Refs inside the viewer */
    var v = {
      progress: viewer.querySelector('[data-cs-progress]'),
      avatar: viewer.querySelector('[data-cs-avatar]'),
      avatarFallback: viewer.querySelector('[data-cs-avatar-fallback]'),
      name: viewer.querySelector('[data-cs-name]'),
      time: viewer.querySelector('[data-cs-time]'),
      image: viewer.querySelector('[data-cs-image]'),
      video: viewer.querySelector('[data-cs-video]'),
      caption: viewer.querySelector('[data-cs-caption]'),
      cta: viewer.querySelector('[data-cs-cta]'),
      ctaLabel: viewer.querySelector('[data-cs-cta-label]'),
      overlay: viewer.querySelector('[data-cs-overlay]'),
      pauseBtn: viewer.querySelector('[data-cs-pause]'),
      pauseIcon: viewer.querySelector('.community-stories-viewer__icon-pause'),
      playIcon: viewer.querySelector('.community-stories-viewer__icon-play'),
      prev: viewer.querySelector('[data-cs-prev]'),
      next: viewer.querySelector('[data-cs-next]'),
      closeBtns: viewer.querySelectorAll('[data-cs-close]')
    };

    /* ── Progress bars ───────────────────────────────────────────
       Rebuilt once on open (bar count = items length). Subsequent
       advance() calls only flip is-done / is-current classes. */
    function renderBars() {
      var list = getItems();
      var html = '';
      for (var i = 0; i < list.length; i++) {
        html += '<span class="community-stories-viewer__bar"><span class="community-stories-viewer__bar-fill"></span></span>';
      }
      v.progress.innerHTML = html;
    }

    function updateBarStates(duration) {
      var bars = v.progress.children;
      for (var i = 0; i < bars.length; i++) {
        var b = bars[i];
        b.classList.remove('is-done', 'is-current');
        if (i < currentIndex) {
          b.classList.add('is-done');
        } else if (i === currentIndex) {
          b.style.setProperty('--cs-slide-duration', duration + 'ms');
          b.classList.add('is-current');
          /* Forced reflow so the same bar re-animates on loop-back. */
          void b.offsetWidth;
        }
      }
    }

    /* ── Playback ─────────────────────────────────────────────── */
    function clearSlideTimer() {
      if (slideTimer) { window.clearTimeout(slideTimer); slideTimer = null; }
    }

    function renderItem() {
      var list = getItems();
      var item = list[currentIndex];
      if (!item) return;
      if (item.avatar) {
        v.avatar.src = item.avatar;
        v.avatar.hidden = false;
        if (v.avatarFallback) { v.avatarFallback.hidden = true; v.avatarFallback.textContent = ''; }
      } else {
        v.avatar.removeAttribute('src');
        v.avatar.hidden = true;
        if (v.avatarFallback) {
          var seed = (item.name || '').trim();
          v.avatarFallback.textContent = seed ? seed.charAt(0).toUpperCase() : '';
          v.avatarFallback.hidden = false;
        }
      }
      v.name.textContent = item.name || '';
      v.time.textContent = item.time || '';

      /* Caption + CTA — hide the overlay when both are empty so the
         bottom of the frame stays clean for media-only stories. */
      v.caption.textContent = item.caption || '';
      if (item.cta_label && item.cta_link) {
        v.cta.href = item.cta_link;
        v.ctaLabel.textContent = item.cta_label;
        v.cta.hidden = false;
      } else {
        v.cta.hidden = true;
      }
      v.overlay.style.display = (item.caption || item.cta_label) ? '' : 'none';
    }

    function playItem() {
      clearSlideTimer();
      var list = getItems();
      var item = list[currentIndex];
      if (!item) return;
      renderItem();

      if (item.type === 'video') {
        v.image.hidden = true;
        v.image.removeAttribute('src');
        v.video.hidden = false;
        v.video.src = item.src;
        v.video.currentTime = 0;

        var fallbackDuration = 15000;
        updateBarStates(fallbackDuration);

        var played = v.video.play();
        if (played && typeof played.catch === 'function') played.catch(function () {});

        v.video.addEventListener('loadedmetadata', function onMeta() {
          v.video.removeEventListener('loadedmetadata', onMeta);
          if (!isFinite(v.video.duration) || v.video.duration <= 0) return;
          updateBarStates(Math.round(v.video.duration * 1000));
        }, { once: true });

        if (reducedMotion.matches) return; /* manual advance only */

        slideTimer = window.setTimeout(advance, fallbackDuration);
      } else {
        v.video.hidden = true;
        v.video.pause();
        v.video.removeAttribute('src');
        v.video.load();

        v.image.hidden = false;
        v.image.src = item.src;
        updateBarStates(imageDuration);

        if (reducedMotion.matches) return;

        slideTimer = window.setTimeout(advance, imageDuration);
      }
    }

    function advance() {
      var list = getItems();
      if (!list.length) return;
      currentIndex = (currentIndex + 1) % list.length; /* loop at end */
      playItem();
    }

    function goBack() {
      var list = getItems();
      if (!list.length) return;
      currentIndex = (currentIndex - 1 + list.length) % list.length;
      playItem();
    }

    v.video.addEventListener('ended', function () {
      if (!viewer.classList.contains('is-open')) return;
      advance();
    });

    /* ── Open / close ────────────────────────────────────────────── */
    function open(index) {
      var list = getItems();
      if (!list.length) return;
      prevFocus = document.activeElement;
      currentIndex = Math.max(0, Math.min(list.length - 1, index));
      paused = false;
      viewer.classList.remove('is-paused');
      syncPauseUi();
      viewer.classList.add('is-open');
      viewer.setAttribute('aria-hidden', 'false');
      viewer.inert = false;
      document.documentElement.classList.add('is-scroll-locked');
      renderBars();
      playItem();
      window.requestAnimationFrame(function () {
        try { v.closeBtns[v.closeBtns.length - 1].focus({ preventScroll: true }); } catch (e) {}
      });
    }

    function close() {
      clearSlideTimer();
      v.video.pause();
      v.video.removeAttribute('src');
      v.video.load();
      v.image.removeAttribute('src');
      viewer.classList.remove('is-open', 'is-paused');
      /* Move focus OUT before marking the viewer hidden — Chrome warns when
         aria-hidden is set on an ancestor of the active element. The close
         button typically holds focus from the click that triggered close.
         Validate prevFocus is still in DOM (a section refresh could have
         detached it) and fall back to blurring the inside descendant. */
      if (prevFocus && typeof prevFocus.focus === 'function' && document.contains(prevFocus)) {
        try { prevFocus.focus({ preventScroll: true }); } catch (e) {}
      } else if (
        document.activeElement &&
        viewer.contains(document.activeElement) &&
        typeof document.activeElement.blur === 'function'
      ) {
        document.activeElement.blur();
      }
      viewer.setAttribute('aria-hidden', 'true');
      viewer.inert = true;
      document.documentElement.classList.remove('is-scroll-locked');
      prevFocus = null;
    }

    /* ── Pause / resume ──────────────────────────────────────────── */
    function syncPauseUi() {
      if (v.pauseIcon) v.pauseIcon.style.display = paused ? 'none' : '';
      if (v.playIcon) v.playIcon.style.display = paused ? '' : 'none';
      if (v.pauseBtn) v.pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    }

    function togglePause() {
      paused = !paused;
      viewer.classList.toggle('is-paused', paused);
      syncPauseUi();
      if (paused) {
        clearSlideTimer();
        if (!v.video.hidden) v.video.pause();
      } else {
        if (!v.video.hidden) {
          var p = v.video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          /* Image slide — restart the timer for the full image duration.
             Slight UX quirk (skips-forward-on-resume is more IG-accurate
             but requires tracking elapsed ms mid-animation). */
          slideTimer = window.setTimeout(advance, imageDuration);
        }
      }
    }

    /* ── Wiring ───────────────────────────────────────────────────
       Event delegation on the root, not per-trigger. Survives DOM
       re-renders (theme editor shuffles things around) and works for
       triggers added after init. The `e.target.closest` walk handles
       clicks on the ring / avatar / name inside the button. */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cs-trigger]');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var idx = parseInt(btn.getAttribute('data-cs-trigger'), 10);
      if (isNaN(idx)) idx = 0;
      open(idx);
    });

    v.closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    });

    v.next.addEventListener('click', function () {
      if (paused) togglePause();
      advance();
    });
    v.prev.addEventListener('click', function () {
      if (paused) togglePause();
      goBack();
    });

    if (v.pauseBtn) {
      v.pauseBtn.addEventListener('click', togglePause);
    }

    document.addEventListener('keydown', function (e) {
      if (!viewer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); }
      else if (e.key === 'ArrowRight') { advance(); }
      else if (e.key === 'ArrowLeft') { goBack(); }
      else if (e.key === ' ') { e.preventDefault(); togglePause(); }
    });

    viewer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = viewer.querySelectorAll(
        'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (!viewer.classList.contains('is-open')) return;
      if (document.hidden && !paused) togglePause();
    });

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', function () {
        if (viewer.classList.contains('is-open')) playItem();
      });
    }

    /* ── Brand-posts grid mouse-drag scrolling ─────────────────────
       The horizontal rail (.community-stories__posts-grid) supports
       touch swipe natively via overflow-x: auto. Desktop users with
       only a mouse had no way to traverse it short of shift-scroll.
       Bind a click-and-drag handler that updates scrollLeft as the
       mouse moves, with a tiny threshold so genuine clicks on the
       linked posts still navigate. Scroll-snap re-engages on release
       so the rail still settles to a post edge. */
    var DRAG_THRESHOLD = 5; /* px before we treat a press as a drag */
    root.querySelectorAll('.community-stories__posts-grid').forEach(function (grid) {
      if (grid.__csDragInit) return;
      grid.__csDragInit = true;

      var isDown = false;
      var startX = 0;
      var startScroll = 0;
      var moved = false;

      grid.addEventListener('mousedown', function (e) {
        if (e.button !== 0) return; /* primary button only */
        isDown = true;
        moved = false;
        startX = e.clientX;
        startScroll = grid.scrollLeft;
        grid.classList.add('is-dragging');
      });

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        grid.classList.remove('is-dragging');
      }

      grid.addEventListener('mouseleave', endDrag);
      document.addEventListener('mouseup', endDrag);

      grid.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > DRAG_THRESHOLD) moved = true;
        if (moved) {
          e.preventDefault(); /* suppress text selection mid-drag */
          grid.scrollLeft = startScroll - dx;
        }
      });

      /* Capture-phase click suppressor — if the press turned into a
         drag, swallow the resulting click so the underlying <a> doesn't
         navigate. Below-threshold presses pass through normally. */
      grid.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      }, true);
    });
  }

  /* ── Instagram auto-feed ───────────────────────────────────────
     Fetches recent media from the Instagram Basic Display API when
     the brand-posts grid is in `instagram` mode. One fetch per section
     instance on mount. sessionStorage cache keeps the API call below
     its 200/hr rate limit for normal browsing. */
  var IG_CACHE_KEY = 'seren_cs_ig_';
  var IG_CACHE_TTL = 15 * 60 * 1000;

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function readIgCache(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || !entry.t || (Date.now() - entry.t) > IG_CACHE_TTL) return null;
      return entry.d;
    } catch (e) { return null; }
  }

  function writeIgCache(key, data) {
    try { window.sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d: data })); }
    catch (e) { /* quota / unavailable — fail silent */ }
  }

  function renderIgPosts(data, target) {
    if (!data || !data.length) return false;
    var html = '';
    for (var i = 0; i < data.length; i++) {
      var p = data[i];
      var src = (p.media_type === 'VIDEO' ? (p.thumbnail_url || p.media_url) : p.media_url);
      if (!src) continue;
      var firstLine = (p.caption || '').split('\n')[0].slice(0, 140);
      var safeCaption = escapeHtml(firstLine);
      var safeSrc = escapeHtml(src);
      var safeLink = escapeHtml(p.permalink || '#');
      html +=
        '<li class="community-stories__post">' +
          '<a class="community-stories__post-link" href="' + safeLink + '" target="_blank" rel="noopener">' +
            '<img class="community-stories__post-img" src="' + safeSrc + '" loading="lazy" alt="' + safeCaption + '">' +
            (safeCaption ? '<span class="community-stories__post-caption">' + safeCaption + '</span>' : '') +
          '</a>' +
        '</li>';
    }
    if (!html) return false;
    target.innerHTML = html;
    target.classList.remove('community-stories__posts-grid--loading');
    target.removeAttribute('aria-busy');
    return true;
  }

  function initIgFeed(wrap) {
    if (wrap.__csIgInit) return;
    wrap.__csIgInit = true;

    var token = wrap.getAttribute('data-cs-ig-token');
    var limit = parseInt(wrap.getAttribute('data-cs-ig-limit'), 10) || 8;
    var target = wrap.querySelector('[data-cs-posts-target]');
    var empty = wrap.querySelector('[data-cs-posts-empty]');
    if (!token || !target) return;

    function fail() {
      target.innerHTML = '';
      target.classList.remove('community-stories__posts-grid--loading');
      target.removeAttribute('aria-busy');
      if (empty) empty.hidden = false;
    }

    var cacheKey = IG_CACHE_KEY + token.slice(-8) + '_' + limit;
    var cached = readIgCache(cacheKey);
    if (cached && renderIgPosts(cached, target)) return;

    var url = 'https://graph.instagram.com/me/media' +
      '?fields=caption,media_type,media_url,permalink,thumbnail_url' +
      '&access_token=' + encodeURIComponent(token) +
      '&limit=' + limit;

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (j) {
        if (!j || !j.data || !j.data.length) { fail(); return; }
        writeIgCache(cacheKey, j.data);
        if (!renderIgPosts(j.data, target)) fail();
      })
      .catch(fail);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-community-stories]').forEach(init);
    root.querySelectorAll('[data-cs-ig-feed]').forEach(initIgFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function syncAria(item) {
    var summary = item.querySelector('.comparison-story__summary');
    if (summary) summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
  }

  function expand(item) {
    var panel = item.querySelector('.comparison-story__body-wrap');
    if (!panel || item.open || item.dataset.animating === 'true') return;
    item.open = true;
    syncAria(item);
    if (prefersReducedMotion()) return;
    item.dataset.animating = 'true';
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    void panel.offsetHeight;
    panel.style.height = target + 'px';
    panel.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.style.height = '';
      item.dataset.animating = '';
    });
  }

  function collapse(item) {
    var panel = item.querySelector('.comparison-story__body-wrap');
    if (!panel || !item.open || item.dataset.animating === 'true') return;
    if (prefersReducedMotion()) {
      item.open = false;
      syncAria(item);
      return;
    }
    item.dataset.animating = 'true';
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    panel.style.height = '0px';
    panel.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      item.open = false;
      syncAria(item);
      panel.style.height = '';
      item.dataset.animating = '';
    });
  }

  function bind(root) {
    if (!root || root.getAttribute('data-comparison-story-init') === 'true') return;
    root.setAttribute('data-comparison-story-init', 'true');

    var items = root.querySelectorAll('.comparison-story__details');

    items.forEach(function (item) {
      var summary = item.querySelector('.comparison-story__summary');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        // Intercept native <details> toggle so we can animate height
        // and enforce single-open across the group.
        e.preventDefault();
        if (item.open) {
          collapse(item);
        } else {
          items.forEach(function (other) {
            if (other !== item && other.open) collapse(other);
          });
          expand(item);
        }
      });

      // Initial aria sync for the first-open item rendered server-side.
      syncAria(item);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-comparison-story]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
(function () {
  var teardowns = new WeakMap();

  function initWrap(wrap) {
    if (!wrap || teardowns.has(wrap)) return;
    var frame = wrap.querySelector('.ct__frame');
    if (!frame) return;

    function update() {
      var scrollable = frame.scrollWidth - frame.clientWidth > 1;
      wrap.classList.toggle('is-scrollable', scrollable);
      if (!scrollable) {
        wrap.classList.remove('is-at-start', 'is-at-end');
        return;
      }
      var left = frame.scrollLeft;
      wrap.classList.toggle('is-at-start', left <= 1);
      wrap.classList.toggle('is-at-end', left + frame.clientWidth >= frame.scrollWidth - 1);
    }

    update();
    frame.addEventListener('scroll', update, { passive: true });

    var observer = null;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(update);
      observer.observe(frame);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    teardowns.set(wrap, function () {
      frame.removeEventListener('scroll', update);
      if (observer) observer.disconnect();
      else window.removeEventListener('resize', update);
    });
  }

  function teardownSection(section) {
    section.querySelectorAll('[data-ct-wrap]').forEach(function (wrap) {
      var fn = teardowns.get(wrap);
      if (fn) { fn(); teardowns.delete(wrap); }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-ct-wrap]').forEach(initWrap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('comparison-table-section')) {
      initAll(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.classList.contains('comparison-table-section')) {
      teardownSection(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-endorsement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRoot(root) {
    if (!root || root.dataset.eeScrollInit === 'true') return;
    root.dataset.eeScrollInit = 'true';

    root.querySelectorAll('.ee__reviews-cta').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', href);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.expert-endorsement-section').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('expert-endorsement-section')) {
      initAll(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expert-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  var teardowns = new WeakMap();

  function initRoot(root) {
    if (!root || teardowns.has(root)) return;
    var cleanups = [];

    // Wire up "open modal" triggers (name buttons + "Read more" buttons).
    root.querySelectorAll('[data-er-open]').forEach(function (btn) {
      var id = btn.getAttribute('data-er-open');
      var dialog = root.querySelector('#' + CSS.escape(id));
      if (!dialog) return;
      function onOpen() {
        if (typeof dialog.showModal === 'function') {
          dialog.showModal();
        } else {
          dialog.setAttribute('open', '');
        }
        if (window.SerenScrollLock) window.SerenScrollLock.lock();
      }
      btn.addEventListener('click', onOpen);
      cleanups.push(function () { btn.removeEventListener('click', onOpen); });
    });

    // Wire up close buttons + backdrop click + native close event
    root.querySelectorAll('.er-modal').forEach(function (dialog) {
      function closeDialog() {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          onDialogClose();
        }
      }
      function onDialogClose() {
        if (window.SerenScrollLock) window.SerenScrollLock.unlock();
      }
      dialog.querySelectorAll('[data-er-close]').forEach(function (btn) {
        btn.addEventListener('click', closeDialog);
        cleanups.push(function () { btn.removeEventListener('click', closeDialog); });
      });
      function onBackdropClick(e) {
        if (e.target === dialog) closeDialog();
      }
      dialog.addEventListener('click', onBackdropClick);
      dialog.addEventListener('close', onDialogClose);
      cleanups.push(function () {
        dialog.removeEventListener('click', onBackdropClick);
        dialog.removeEventListener('close', onDialogClose);
      });
    });

    teardowns.set(root, function () {
      cleanups.forEach(function (fn) { fn(); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.er').forEach(initRoot);
  }

  function teardownSection(section) {
    section.querySelectorAll('.er').forEach(function (root) {
      var fn = teardowns.get(root);
      if (fn) { fn(); teardowns.delete(root); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('expert-reviews-section')) {
      initAll(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.classList.contains('expert-reviews-section')) {
      teardownSection(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  var teardowns = new WeakMap();

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function expand(item) {
    var panel = item.querySelector('.faq__a-wrap');
    if (!panel || item.open || item.dataset.animating === 'true') return;
    item.open = true;
    if (prefersReducedMotion()) return;
    item.dataset.animating = 'true';
    var target = panel.scrollHeight;
    panel.style.height = '0px';
    /* force reflow */
    void panel.offsetHeight;
    panel.style.height = target + 'px';
    panel.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      panel.style.height = '';
      item.dataset.animating = '';
    });
  }

  function collapse(item) {
    var panel = item.querySelector('.faq__a-wrap');
    if (!panel || !item.open || item.dataset.animating === 'true') return;
    if (prefersReducedMotion()) {
      item.open = false;
      return;
    }
    item.dataset.animating = 'true';
    panel.style.height = panel.scrollHeight + 'px';
    void panel.offsetHeight;
    panel.style.height = '0px';
    panel.addEventListener('transitionend', function onEnd(e) {
      if (e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onEnd);
      item.open = false;
      panel.style.height = '';
      item.dataset.animating = '';
    });
  }

  function initRoot(root) {
    if (!root || teardowns.has(root)) return;
    var cleanups = [];
    var singleOpen = root.hasAttribute('data-faq-single');
    var items = root.querySelectorAll('.faq__item');
    var tabs = root.querySelectorAll('.tablist__tab[data-faq-filter]');

    /* Intercept summary clicks to animate the panel height. */
    items.forEach(function (item) {
      var summary = item.querySelector('.faq__q');
      if (!summary) return;
      function onClick(e) {
        e.preventDefault();
        if (item.open) {
          collapse(item);
        } else {
          if (singleOpen) {
            items.forEach(function (other) {
              if (other !== item && other.open) collapse(other);
            });
          }
          expand(item);
        }
      }
      summary.addEventListener('click', onClick);
      cleanups.push(function () { summary.removeEventListener('click', onClick); });
    });

    /* Category tablist: click + arrow-key navigation.
       Fade the list out, swap visibility, fade back in. */
    var list = root.querySelector('.faq__list');
    if (tabs.length > 0) {
      var emptyMsg = root.querySelector('[data-faq-empty]');
      function applyFilter(target) {
        var shown = 0;
        items.forEach(function (item) {
          var cat = item.getAttribute('data-category') || '';
          var show = target === '__all__' || cat === target;
          if (show) shown++;
          item.hidden = !show;
          if (!show && item.open) {
            item.open = false;
            var panel = item.querySelector('.faq__a-wrap');
            if (panel) panel.style.height = '';
          }
        });
        /* A topic with no questions gets a short message, not a blank list. */
        if (emptyMsg) emptyMsg.hidden = shown > 0;
      }

      function activate(tab) {
        var target = tab.getAttribute('data-faq-filter');
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        if (!list || prefersReducedMotion()) {
          applyFilter(target);
          return;
        }
        list.classList.add('is-fading');
        var done = false;
        function swap() {
          if (done) return;
          done = true;
          applyFilter(target);
          requestAnimationFrame(function () {
            list.classList.remove('is-fading');
          });
        }
        list.addEventListener('transitionend', function onEnd(e) {
          if (e.target !== list || e.propertyName !== 'opacity') return;
          list.removeEventListener('transitionend', onEnd);
          swap();
        });
        /* Safety: guarantee the swap fires even if transitionend is missed */
        setTimeout(swap, 320);
      }

      tabs.forEach(function (tab, index) {
        function onClick() { activate(tab); }
        function onKey(e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          var next = tabs[(index + dir + tabs.length) % tabs.length];
          next.focus();
          activate(next);
        }
        tab.addEventListener('click', onClick);
        tab.addEventListener('keydown', onKey);
        cleanups.push(function () {
          tab.removeEventListener('click', onClick);
          tab.removeEventListener('keydown', onKey);
        });
      });
    }

    teardowns.set(root, function () {
      cleanups.forEach(function (fn) { fn(); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-faq]').forEach(initRoot);
  }

  function teardownSection(section) {
    section.querySelectorAll('[data-faq]').forEach(function (root) {
      var fn = teardowns.get(root);
      if (fn) { fn(); teardowns.delete(root); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('faq-section')) {
      initAll(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.classList.contains('faq-section')) {
      teardownSection(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Newsletter is a native Shopify customer form now (success/errors render from
  // Liquid via form.posted_successfully? / form.errors). No JS — an AJAX POST
  // bypasses Shopify's reCAPTCHA challenge token and gets rejected (400). This
  // matches Dawn's footer pattern.

  // ── Brand wordmark ─────────────────────────────────────────────────────
  // Footer is `limit: 1`, so a single wordmark is the only case to handle.
  var wordmark = document.querySelector('[data-footer-wordmark]');
  if (!wordmark) return;
  var asset = wordmark.querySelector('.footer__wordmark-asset');
  if (!asset) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Auto-fit text wordmark.
  // Scale font-size so the text fills the container width on a single line at
  // any length. Measures at the CURRENT rendered size and scales proportionally,
  // so the function makes a single layout-affecting write per call (no
  // baseline-size shrink → grow that would double the shift). 0.96 leaves a
  // tiny breathing margin so the letters don't kiss the container edges.
  var textEl = wordmark.querySelector('[data-footer-wordmark-text]');
  if (textEl) {
    var refit = function () {
      var parentW = wordmark.clientWidth;
      if (!parentW) return;
      var current = parseFloat(window.getComputedStyle(textEl).fontSize) || 100;
      var textW = textEl.scrollWidth;
      if (!textW) return;
      textEl.style.fontSize = (current * parentW / textW) * 0.96 + 'px';
    };

    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(refit);
    } else {
      refit();
    }

    // ResizeObserver fires only on actual element size change and dedupes
    // natively — cheaper than a manually-debounced window.resize listener.
    if (window.ResizeObserver) {
      new ResizeObserver(refit).observe(wordmark);
    } else {
      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(refit, 100);
      });
    }
  }

  // Strip the class on animationend so the keyframes can re-fire on a later
  // "arrived at bottom" transition.
  asset.addEventListener('animationend', function () {
    wordmark.classList.remove('is-wiggling');
  });

  if (prefersReducedMotion) return;

  // Scroll-to-bottom trigger.
  // Fires the jello only on the transition into "at end of page", not when
  // scrolling back up. wasAtBottom gates the re-trigger so a single arrival
  // fires once; user must leave the bottom and return for another fire.
  var BOTTOM_BUFFER = 16; // px tolerance for sub-pixel rounding + iOS overscroll
  var wasAtBottom = false;
  var ticking = false;

  function trigger() {
    wordmark.classList.remove('is-wiggling');
    void wordmark.offsetWidth; // reflow so re-adding the class restarts keyframes
    wordmark.classList.add('is-wiggling');
  }

  function check() {
    var nearBottom =
      (window.scrollY + window.innerHeight) >=
      (document.documentElement.scrollHeight - BOTTOM_BUFFER);
    if (nearBottom && !wasAtBottom) trigger();
    wasAtBottom = nearBottom;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      check();
      ticking = false;
    });
  }, { passive: true });

  // Re-check on resize since viewport changes can put us at/away from bottom.
  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(check, 100);
  });

  // Initial check — handles short pages where the user starts at the bottom,
  // and gives the section editor's preview a fire on first paint.
  check();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-header-root]');
  if (!root) return;
  var header = root.querySelector('[data-header]');
  var sticky = header && header.getAttribute('data-sticky') === 'true';
  var drawer = root.querySelector('[data-mobile-drawer]');
  var openBtn = root.querySelector('[data-menu-drawer-open]');
  var closeEls = root.querySelectorAll('[data-menu-drawer-close]');
  var panel = drawer ? drawer.querySelector('.header__drawer-panel') : null;

  var closeCleanupTimer = null;
  var panelTransitionEndHandler = null;
  var closePending = false;
  var lastFocus = null;
  var restorePageInert = null;

  /* Brief scale bump when the count changes (CSS .is-bumping). A timer
     clears the class, so it also clears when reduced motion has the
     animation switched off. */
  function bumpCartCount(el) {
    if (el.classList.contains('is-bumping')) return;
    el.classList.add('is-bumping');
    setTimeout(function () {
      el.classList.remove('is-bumping');
    }, 400);
  }

  function updateCartCount(detail) {
    var cart = detail && detail.cart;
    var n = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    root.querySelectorAll('[data-header-cart-count]').forEach(function (el) {
      var changed = (el.textContent || '').trim() !== String(n);
      el.textContent = String(n);
      el.classList.toggle('is-empty', n === 0);
      if (changed && n > 0) bumpCartCount(el);
    });
  }

  document.addEventListener('theme:cart:updated', function (e) {
    updateCartCount(e.detail);
  });

  function clearCloseAnimation() {
    if (closeCleanupTimer) {
      clearTimeout(closeCleanupTimer);
      closeCleanupTimer = null;
    }
    if (panel && panelTransitionEndHandler) {
      panel.removeEventListener('transitionend', panelTransitionEndHandler);
      panelTransitionEndHandler = null;
    }
  }

  /* Tabbable rows inside the open panel, in DOM order: the shared selector
     plus <summary> (the accordion rows), minus anything not rendered — links
     inside a collapsed <details> tier, display:none app content. */
  function isInsideClosedDetails(el) {
    var d = el.parentElement && el.parentElement.closest('details:not([open])');
    while (d) {
      var summary = d.querySelector(':scope > summary');
      if (!summary || !summary.contains(el)) return true;
      d = d.parentElement && d.parentElement.closest('details:not([open])');
    }
    return false;
  }

  function drawerFocusables() {
    if (!panel || !window.SerenFocusTrap) return [];
    return window.SerenFocusTrap.focusable(panel, 'summary').filter(function (el) {
      return el.getClientRects().length > 0 && !isInsideClosedDetails(el);
    });
  }

  /* Escape closes; Tab / Shift+Tab wrap inside the panel (the same handler
     the cart drawer uses — window.SerenFocusTrap in assets/theme.js). An
     Escape the predictive-search input already consumed (collapsing its
     suggestions) is left alone, so the first Escape closes the list and the
     second closes the drawer. */
  function onDrawerKeydown(e) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      if (e.defaultPrevented) return;
      e.preventDefault();
      setDrawerOpen(false);
      return;
    }
    if (e.key !== 'Tab' || !window.SerenFocusTrap) return;
    window.SerenFocusTrap.trapTab(e, drawerFocusables());
  }

  function releasePageShell() {
    document.removeEventListener('keydown', onDrawerKeydown);
    if (restorePageInert) {
      restorePageInert();
      restorePageInert = null;
    }
  }

  function finishDrawerClose() {
    if (!closePending) return;
    closePending = false;
    clearCloseAnimation();
    if (!drawer) return;
    /* Move focus OUT of the drawer BEFORE marking it hidden. Chrome flags
       an aria-hidden ancestor of a focused element ("Blocked aria-hidden
       on an element because its descendant retained focus"). The close
       button typically holds focus from the click that triggered close.
       Validate lastFocus is still in the DOM — a section refresh while
       the drawer was open can detach the original trigger. */
    if (
      lastFocus &&
      typeof lastFocus.focus === 'function' &&
      document.contains(lastFocus)
    ) {
      lastFocus.focus();
    } else if (
      document.activeElement &&
      drawer.contains(document.activeElement) &&
      typeof document.activeElement.blur === 'function'
    ) {
      document.activeElement.blur();
    }
    drawer.setAttribute('aria-hidden', 'true');
    /* `inert` is the modern equivalent — forces focus out and removes
       descendants from the tab order at the platform level. Belt-and-
       suspenders alongside aria-hidden. */
    drawer.inert = true;
    root.classList.remove('header-menu-open');
    if (window.SerenScrollLock) window.SerenScrollLock.unlock();
    else document.documentElement.classList.remove('is-scroll-locked');
    lastFocus = null;
  }

  function setDrawerOpen(open) {
    if (!drawer || !openBtn) return;

    if (open) {
      clearCloseAnimation();
      closePending = false;
      lastFocus =
        document.activeElement && document.activeElement !== document.body
          ? document.activeElement
          : openBtn;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.inert = false;
      openBtn.setAttribute('aria-expanded', 'true');
      root.classList.add('header-menu-open');
      if (window.SerenScrollLock) window.SerenScrollLock.lock();
      else document.documentElement.classList.add('is-scroll-locked');
      /* Page shell behind the drawer (header bar, main, footer, promo bars)
         goes inert while it is open: out of the tab order and hidden from
         assistive tech, matching aria-modal. Restored on close. */
      if (!restorePageInert && window.SerenFocusTrap) {
        restorePageInert = window.SerenFocusTrap.inertOutside(drawer);
      }
      document.removeEventListener('keydown', onDrawerKeydown);
      document.addEventListener('keydown', onDrawerKeydown);
      requestAnimationFrame(function () {
        if (!drawer.classList.contains('is-open')) return;
        var focusables = drawerFocusables();
        var target = focusables.length ? focusables[0] : panel;
        if (target && typeof target.focus === 'function') target.focus();
      });
      return;
    }

    if (!drawer.classList.contains('is-open')) return;

    clearCloseAnimation();
    closePending = true;
    /* Release the page shell now, not after the slide-out: the trigger must be
       focusable again when finishDrawerClose() returns focus to it, and a cart
       drawer opening over this one must not land inside an inert wrapper. */
    releasePageShell();

    drawer.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');

    function onPanelTransitionEnd(e) {
      if (!panel || e.target !== panel) return;
      if (e.propertyName !== 'transform') return;
      finishDrawerClose();
    }

    if (panel) {
      panelTransitionEndHandler = onPanelTransitionEnd;
      panel.addEventListener('transitionend', panelTransitionEndHandler);
    }

    /* Fallback if transitionend never fires — match SEREN_DRAWER_CLOSE_FALLBACK_MS in assets/theme.js. */
    closeCleanupTimer = window.setTimeout(finishDrawerClose, 500);
  }

  var mqDesktop = window.matchMedia('(min-width: 1024px)');
  function closeDrawerIfDesktop() {
    if (mqDesktop.matches && drawer && drawer.classList.contains('is-open')) {
      setDrawerOpen(false);
    }
  }
  if (typeof mqDesktop.addEventListener === 'function') {
    mqDesktop.addEventListener('change', closeDrawerIfDesktop);
  } else if (typeof mqDesktop.addListener === 'function') {
    mqDesktop.addListener(closeDrawerIfDesktop);
  }
  window.addEventListener('resize', closeDrawerIfDesktop);

  if (openBtn && drawer) {
    openBtn.addEventListener('click', function () {
      var open = !drawer.classList.contains('is-open');
      setDrawerOpen(open);
    });
    closeEls.forEach(function (el) {
      el.addEventListener('click', function () {
        setDrawerOpen(false);
      });
    });
  }

  /* ── Desktop flyouts + mega menus ─────────────────────────────────
     They open on :hover / :focus-within in CSS. This keeps each parent
     link's aria-expanded in step with what is actually showing, and lets
     Escape dismiss an open panel (focus returns to the parent link) via
     .is-dismissed, which CSS honours until both pointer and focus have
     left the item. */
  root.querySelectorAll('.header__nav-item--mega, .header__nav-item--flyout').forEach(function (item) {
    var trigger = item.querySelector(':scope > .header__nav-link');
    if (!trigger) return;

    function setExpanded(open) {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function sync() {
      setExpanded(
        !item.classList.contains('is-dismissed') &&
          (item.matches(':hover') || item.contains(document.activeElement))
      );
    }

    item.addEventListener('mouseenter', sync);
    item.addEventListener('focusin', sync);
    item.addEventListener('mouseleave', function () {
      if (!item.contains(document.activeElement)) item.classList.remove('is-dismissed');
      sync();
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget && item.contains(e.relatedTarget)) return;
      var hovered = item.matches(':hover');
      if (!hovered) item.classList.remove('is-dismissed');
      setExpanded(hovered && !item.classList.contains('is-dismissed'));
    });
    item.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || trigger.getAttribute('aria-expanded') !== 'true') return;
      e.preventDefault();
      item.classList.add('is-dismissed');
      setExpanded(false);
      if (document.activeElement !== trigger) trigger.focus();
    });
  });

  if (sticky && header) {
    /* Scrolled-state watcher (hysteresis-gated to prevent flicker during iOS
       Safari address-bar scrolls and momentum-bounce at the top of the page).
       Dark-section overlap detection is delegated to SerenDarkOverlap so all
       sticky bars share one rAF loop and one scheme-cache. */
    var SCROLL_ON = 24;
    var SCROLL_OFF = 4;
    var ticking = false;
    var lastScrolled = false;

    function applyScrolledState() {
      ticking = false;
      var y = window.scrollY;
      var nextScrolled = lastScrolled ? y > SCROLL_OFF : y > SCROLL_ON;
      if (nextScrolled !== lastScrolled) {
        lastScrolled = nextScrolled;
        header.classList.toggle('header--scrolled', nextScrolled);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(applyScrolledState);
    }

    applyScrolledState();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    if (window.SerenDarkOverlap) {
      window.SerenDarkOverlap.observe(header, { className: 'header--on-dark' });
    }
  }

  /* r10 overlay layout: the bar starts transparent over the first screen.
     Dark sections flip its palette through SerenDarkOverlap (registered
     here when the header is not sticky, since the sticky branch above
     already did); a hero with a dark scrim (overlay / center layouts) is
     not a dark scheme, so the same mid-point test runs against it and
     toggles `header--over-media`. One rAF-coalesced scroll loop. */
  if (header && header.hasAttribute('data-header-overlay')) {
    if (!sticky && window.SerenDarkOverlap) {
      window.SerenDarkOverlap.observe(header, { className: 'header--on-dark' });
    }
    var overlayTicking = false;
    var overMedia = null;
    function heroMedia() {
      return document.querySelector('#MainContent .hero--overlay, #MainContent .hero--center');
    }
    function applyOverMedia() {
      overlayTicking = false;
      var hero = heroMedia();
      var next = false;
      if (hero) {
        var bar = header.getBoundingClientRect();
        var y = bar.top + bar.height * 0.5;
        var r = hero.getBoundingClientRect();
        next = r.top <= y && r.bottom > y;
      }
      if (next !== overMedia) {
        overMedia = next;
        header.classList.toggle('header--over-media', next);
      }
    }
    function onOverlayScroll() {
      if (overlayTicking) return;
      overlayTicking = true;
      window.requestAnimationFrame(applyOverMedia);
    }
    applyOverMedia();
    window.addEventListener('scroll', onOverlayScroll, { passive: true });
    window.addEventListener('resize', onOverlayScroll, { passive: true });
    document.addEventListener('shopify:section:load', onOverlayScroll);
  }

  document.addEventListener('theme:drawer:open', function (ev) {
    if (!ev.detail || ev.detail.name !== 'cart') return;
    if (drawer && drawer.classList.contains('is-open')) {
      setDrawerOpen(false);
    }
  });

  /* ── Nav-overflow detection ─────────────────────────────────────
     When the desktop nav-list is wider than its grid cell (too many
     items / long labels for the current viewport), drop the whole
     desktop nav and let the hamburger handle navigation instead.
     The drawer renders the same `section.settings.menu.links` source
     via `snippets/menu-mobile-tier.liquid` (see the markup section
     above where it's rendered into `.header__drawer-body`), so users
     lose nothing — just a cleaner bar.

     Measurement strategy: the nav-list is `flex-wrap: nowrap`, so its
     `scrollWidth` reports the natural required width regardless of
     visible state. We compare against the wrapping nav's `clientWidth`
     (the available column width). To re-evaluate on resize without
     flicker, we temporarily remove the overflow class, force a layout
     read (the `scrollWidth` access does this synchronously), then
     re-apply if still overflowing — all within one frame, so the
     browser paints once. Disabled below the 1024px desktop breakpoint
     because the hamburger is already in charge there. */
  var navList = root.querySelector('[data-header-nav-list]');
  var desktopNav = root.querySelector('[data-header-desktop-nav]');
  /* Force-hamburger setting renders the overflow class server-side
     and adds `header--nav-force-overflow` as a sentinel. JS skips all
     measurement in that case — the class is intentional, not derived.
     Without this guard the resize handler would keep removing and
     re-adding the class on every viewport change. */
  var forceHamburger = header && header.classList.contains('header--nav-force-overflow');
  if (header && navList && desktopNav && !forceHamburger) {
    function measureNavOverflow() {
      /* +1 absorbs sub-pixel rounding noise that would otherwise flip
         the class on every other resize tick. */
      var wantOverflow = mqDesktop.matches
        && navList.scrollWidth > desktopNav.clientWidth + 1;
      var hasOverflow = header.classList.contains('header--nav-overflow');
      /* Only mutate when the desired and current states diverge. Avoids
         spurious MutationObserver fires (some analytics/pixel SDKs hook
         the header) and keeps the resize handler cheap during drags. */
      if (wantOverflow && !hasOverflow) {
        header.classList.add('header--nav-overflow');
      } else if (!wantOverflow && hasOverflow) {
        header.classList.remove('header--nav-overflow');
      }
    }

    /* Debounce resize so we don't measure on every pixel of a drag. */
    var navResizeTimer = null;
    function scheduleNavMeasure() {
      if (navResizeTimer) clearTimeout(navResizeTimer);
      navResizeTimer = setTimeout(measureNavOverflow, 80);
    }

    measureNavOverflow();
    window.addEventListener('resize', scheduleNavMeasure, { passive: true });

    /* Web fonts change item widths after the swap. Re-measure once
       fonts are ready so we don't get a stuck-on or stuck-off state
       from the initial fallback-font layout. */
    if (document.fonts && typeof document.fonts.ready === 'object') {
      document.fonts.ready.then(measureNavOverflow);
    }

    /* In the Shopify editor, blocks shuffle on shopify:block:reorder /
       shopify:section:load — re-measure so the nav state stays right. */
    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target && ev.target.contains(header)) {
        measureNavOverflow();
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
/* Deferred hero-video autoplay. The <video> renders without `autoplay` and
   with preload="none" (see the markup comment) so page load streams ZERO
   video bytes — the preloaded poster is the visual until the page settles.
   Once `window.load` fires (or immediately if it already has), start
   playback. Save-Data / prefers-reduced-data visitors stay on the poster;
   the perceived difference for everyone else is ~1-2s of still image on
   slow connections. */
(function () {
  function startHeroVideos() {
    if (navigator.connection && navigator.connection.saveData) return;
    if (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-data: reduce)').matches
    ) {
      return;
    }
    document
      .querySelectorAll('video.hero__video[data-hero-deferred-autoplay]')
      .forEach(function (v) {
        if (typeof v.play === 'function') {
          v.play().catch(function () {});
        }
      });
  }

  function whenSettled(fn) {
    if (document.readyState === 'complete') {
      window.requestAnimationFrame(fn);
    } else {
      window.addEventListener(
        'load',
        function () {
          window.requestAnimationFrame(fn);
        },
        { once: true }
      );
    }
  }

  whenSettled(startHeroVideos);
  /* Theme editor: a re-rendered hero section arrives long after window.load —
     kick its video directly. */
  document.addEventListener('shopify:section:load', function () {
    whenSettled(startHeroVideos);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  var teardowns = new WeakMap();

  function readColumnGap(track) {
    var cs = window.getComputedStyle(track);
    return parseFloat(cs.columnGap || cs.gap) || 0;
  }

  function initWrap(wrap) {
    if (!wrap || teardowns.has(wrap)) return;
    var track = wrap.querySelector('.hts__track');
    if (!track) return;

    /* Cached across scroll events; refreshed on resize (gap is tied to CSS
       breakpoints, not scroll state, so computedStyle only needs to be read
       when layout could have changed). */
    var cachedGap = readColumnGap(track);

    function update() {
      /* Measure the cards' natural laid-out width (sum of card widths +
         gaps). We can't rely on `scrollWidth > clientWidth` here because
         when `.is-scrollable` is applied, the CSS adds `padding-inline`
         to the track, inflating scrollWidth and creating a stuck-open
         feedback loop on viewport resize. Measuring children directly
         is padding-agnostic and always reflects the true overflow state. */
      var cards = track.querySelectorAll('.hts__step');
      if (cards.length === 0) {
        wrap.classList.remove('is-scrollable', 'is-at-start', 'is-at-end');
        track.removeAttribute('tabindex');
        return;
      }
      var gap = cachedGap;
      var naturalWidth = 0;
      for (var i = 0; i < cards.length; i++) {
        naturalWidth += cards[i].offsetWidth;
        if (i > 0) naturalWidth += gap;
      }

      if (naturalWidth <= track.clientWidth + 2) {
        wrap.classList.remove('is-scrollable', 'is-at-start', 'is-at-end');
        track.removeAttribute('tabindex');
        return;
      }

      wrap.classList.add('is-scrollable');
      track.setAttribute('tabindex', '0');
      var sl = track.scrollLeft;
      var max = track.scrollWidth - track.clientWidth;

      /* "At start" lingers until the user has scrolled past ~half of the
         first card plus the gap — fade + swipe hint flip only once the
         viewer has genuinely moved on to card 2. */
      var startThreshold = cards[0].offsetWidth * 0.5 + gap * 0.5;

      wrap.classList.toggle('is-at-start', sl < startThreshold);
      wrap.classList.toggle('is-at-end', sl >= max - 2);
    }

    track.addEventListener('scroll', update, { passive: true });

    function onLayoutChange() {
      cachedGap = readColumnGap(track);
      update();
    }

    var observer = null;
    if (typeof ResizeObserver !== 'undefined') {
      observer = new ResizeObserver(onLayoutChange);
      observer.observe(track);
    } else {
      window.addEventListener('resize', onLayoutChange, { passive: true });
    }
    /* iOS Safari can land on card 2 at initial mount for two reasons:
       (1) `.is-scrollable` adds padding-inline AFTER first paint, and
       the browser's snap resolver picks the wrong card before layout
       settles; (2) first-card images finish loading LATER and trigger
       another layout shift that iOS re-anchors against. Fix: factor
       out a `pinToStart()` that disables snap + smooth-scroll, resets
       scrollLeft to its target, forces a reflow, then restores across
       two rAFs. Call it initially and re-call after every late layout
       trigger (image load, video metadata load, window.load) — but
       only until the user has actually scrolled.

       Desktop variant: at >=1024px, the viewport fits ~3 cards, so
       centering card 1 leaves visible empty space on the left. Pin
       to card 2 centered instead — card 1 sits to its left, card 3
       to its right, the section reads visually balanced. Mobile +
       tablet keep card 1 centered (only one card fits at a time, so
       the gap-on-the-left issue doesn't apply). */
    var userScrolled = false;
    function markScrolled() {
      if (track.scrollLeft > 4) userScrolled = true;
    }
    track.addEventListener('scroll', markScrolled, { passive: true });

    function getInitialTargetScrollLeft() {
      if (!wrap.classList.contains('is-scrollable')) return 0;
      if (!window.matchMedia('(min-width: 1024px)').matches) return 0;
      var trackCards = track.querySelectorAll('.hts__step');
      if (trackCards.length < 2) return 0;
      var card2 = trackCards[1];
      // Center card 2 in the visible viewport: card-2 offsetLeft minus
      // (viewport - card-2 width) / 2 puts the card's center on the
      // viewport's center. Clamped >= 0 in case the math underflows.
      return Math.max(0, card2.offsetLeft - (track.clientWidth - card2.offsetWidth) / 2);
    }

    function pinToStart() {
      if (userScrolled) return;
      if (!wrap.classList.contains('is-scrollable')) return;
      var prevSnap = track.style.scrollSnapType;
      var prevBehavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = getInitialTargetScrollLeft();
      void track.offsetWidth;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          track.style.scrollSnapType = prevSnap;
          track.style.scrollBehavior = prevBehavior;
        });
      });
    }

    update();
    pinToStart();

    /* Re-pin when late-loading media in the first card settles layout. */
    var firstCard = track.querySelector('.hts__step');
    var mediaLoadCleanups = [];
    if (firstCard) {
      firstCard.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return;
        var handler = function () { pinToStart(); };
        img.addEventListener('load', handler, { once: true });
        mediaLoadCleanups.push(function () { img.removeEventListener('load', handler); });
      });
      firstCard.querySelectorAll('video').forEach(function (vid) {
        var handler = function () { pinToStart(); };
        vid.addEventListener('loadedmetadata', handler, { once: true });
        mediaLoadCleanups.push(function () { vid.removeEventListener('loadedmetadata', handler); });
      });
    }

    /* Final safety net: once every resource is loaded, pin once more. */
    var onWindowLoad = null;
    if (document.readyState !== 'complete') {
      onWindowLoad = function () { pinToStart(); };
      window.addEventListener('load', onWindowLoad, { once: true });
    }

    teardowns.set(wrap, function () {
      track.removeEventListener('scroll', update);
      track.removeEventListener('scroll', markScrolled);
      if (observer) observer.disconnect();
      else window.removeEventListener('resize', onLayoutChange);
      mediaLoadCleanups.forEach(function (fn) { fn(); });
      if (onWindowLoad) window.removeEventListener('load', onWindowLoad);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-hts-wrap]').forEach(initWrap);
  }

  function teardownSection(section) {
    section.querySelectorAll('[data-hts-wrap]').forEach(function (wrap) {
      var fn = teardowns.get(wrap);
      if (fn) { fn(); teardowns.delete(wrap); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('how-to-steps-section')) {
      initAll(e.target);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.classList.contains('how-to-steps-section')) {
      teardownSection(e.target);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["order-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.customElements && customElements.get('seren-order-tracking')) return;

    var WIDGET_SRC = 'https://www.17track.net/externalcall.js';
    var widgetLoading = null;

    // Lazy-load the 17TRACK widget script once, on first submit — keeps it off
    // the page-load critical path (no request until the shopper actually tracks).
    function loadWidget() {
      if (window.YQV5) return Promise.resolve();
      if (widgetLoading) return widgetLoading;
      widgetLoading = new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = WIDGET_SRC;
        s.async = true;
        s.onload = function () { resolve(); };
        s.onerror = function () { widgetLoading = null; reject(); };
        document.head.appendChild(s);
      });
      return widgetLoading;
    }

    function Tracker() { return Reflect.construct(HTMLElement, [], Tracker); }
    Tracker.prototype = Object.create(HTMLElement.prototype);
    Tracker.prototype.constructor = Tracker;

    Tracker.prototype.connectedCallback = function () {
      if (this._init) return;
      this._init = true;
      this.form = this.querySelector('[data-tracking-form]');
      this.input = this.querySelector('[data-tracking-input]');
      this.submit = this.querySelector('[data-tracking-submit]');
      this.results = this.querySelector('[data-tracking-results]');
      this.widget = this.querySelector('[data-tracking-widget]');
      this.status = this.querySelector('[data-tracking-status]');
      if (!this.form || !this.widget) return;
      var self = this;
      this.form.addEventListener('submit', function (e) {
        e.preventDefault();
        self.track();
      });
    };

    Tracker.prototype.text = function (name) {
      return this.getAttribute('data-text-' + name) || '';
    };

    Tracker.prototype.setStatus = function (msg) {
      if (!this.status) return;
      this.status.textContent = msg || '';
      this.status.hidden = !msg;
    };

    // Keep the "Loading" line up until the widget actually paints, so the
    // results area never shows as an empty gap between the two.
    Tracker.prototype.stopWatching = function () {
      if (this.paintObserver) this.paintObserver.disconnect();
      clearTimeout(this.paintTimer);
      this.paintObserver = null;
    };

    Tracker.prototype.clearStatusWhenPainted = function () {
      var self = this;
      this.stopWatching();
      if (this.widget.children.length || !('MutationObserver' in window)) {
        this.setStatus('');
        return;
      }
      this.paintObserver = new MutationObserver(function () {
        if (!self.widget.children.length) return;
        self.stopWatching();
        self.setStatus('');
      });
      this.paintTimer = setTimeout(function () {
        self.stopWatching();
        if (!self.widget.children.length) {
          self.setStatus(self.text('unavailable'));
        }
      }, 15000);
      this.paintObserver.observe(this.widget, { childList: true });
    };

    Tracker.prototype.done = function () {
      this.busy = false;
      this.submit.removeAttribute('aria-busy');
    };

    Tracker.prototype.track = function () {
      // Double-submit guard: ignore new submits while a lookup is starting.
      if (this.busy) return;
      var number = (this.input.value || '').trim();
      if (!number) { this.input.focus(); return; }
      var self = this;
      this.busy = true;
      this.stopWatching();
      this.results.hidden = false;
      this.widget.innerHTML = '';
      this.setStatus(this.text('loading'));
      this.submit.setAttribute('aria-busy', 'true');
      loadWidget().then(function () {
        try {
          window.YQV5.trackSingle({
            YQ_ContainerId: self.widget.id,
            YQ_Height: 560,
            YQ_Lang: (document.documentElement.lang || 'en').slice(0, 2),
            YQ_Num: number
          });
        } catch (err) {
          self.setStatus(self.text('unavailable'));
          self.done();
          return;
        }
        self.clearStatusWhenPainted();
        self.done();
        try {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          self.results.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        } catch (e) {}
      }).catch(function () {
        self.setStatus(self.text('load-failed'));
        self.done();
      });
    };

    window.customElements.define('seren-order-tracking', Tracker);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-power"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Extract the first numeric run from the value string (handles
  // decimals and comma-grouped thousands). Example inputs:
  //   "85%"              → 85
  //   "4.7 ★★★★★"        → 4.7
  //   "20,000+"          → 20000
  //   "$1,250 saved"     → 1250
  function extractNumber(text) {
    var match = text.match(/(\d{1,3}(?:,\d{3})+(?:\.\d+)?|\d+(?:\.\d+)?)/);
    if (!match) return null;
    var numStr = match[0];
    var n = parseFloat(numStr.replace(/,/g, ''));
    if (isNaN(n)) return null;
    return {
      number: n,
      startIdx: match.index,
      endIdx: match.index + numStr.length,
      hasDecimal: numStr.indexOf('.') !== -1,
      hasComma: numStr.indexOf(',') !== -1
    };
  }

  function formatNumber(n, hasDecimal, hasComma) {
    var str = hasDecimal
      ? (Math.round(n * 10) / 10).toFixed(1)
      : String(Math.floor(n));
    if (hasComma) {
      var parts = str.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      str = parts.join('.');
    }
    return str;
  }

  function animateEl(el, durationMs) {
    var original = el.getAttribute('data-pp-value') || el.textContent;
    var parsed = extractNumber(original);
    if (!parsed) return;
    var prefix = original.slice(0, parsed.startIdx);
    var suffix = original.slice(parsed.endIdx);
    var target = parsed.number;
    var start = null;

    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / durationMs);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + formatNumber(val, parsed.hasDecimal, parsed.hasComma) + suffix;
      if (p < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = original;
      }
    }
    requestAnimationFrame(step);
  }

  function init(root) {
    if (!root || root.__ppInit) return;
    root.__ppInit = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var values = root.querySelectorAll('[data-pp-value]');
    if (!values.length) return;

    function reveal() {
      values.forEach(function (el) {
        if (reduce) {
          el.textContent = el.getAttribute('data-pp-value') || el.textContent;
          return;
        }
        animateEl(el, 1400);
      });
    }

    if (reduce) {
      reveal();
      return;
    }

    var obs = new IntersectionObserver(
      function (entries, o) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          o.unobserve(entry.target);
          reveal();
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.15 }
    );
    obs.observe(root);
    root.__ppObs = obs;
  }

  function teardown(root) {
    if (!root || !root.__ppObs) return;
    root.__ppObs.disconnect();
    root.__ppObs = null;
    root.__ppInit = false;
  }

  document.querySelectorAll('[data-pp-animate]').forEach(init);
  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev.target) return;
    ev.target.querySelectorAll('[data-pp-animate]').forEach(init);
  });
  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev.target) return;
    ev.target.querySelectorAll('[data-pp-animate]').forEach(teardown);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    (function () {
      'use strict';

      if (window.customElements && customElements.get('product-recommendations')) {
        return;
      }

      var ProductRecommendations = function () {
        return Reflect.construct(HTMLElement, [], ProductRecommendations);
      };

      ProductRecommendations.prototype = Object.create(HTMLElement.prototype);
      ProductRecommendations.prototype.constructor = ProductRecommendations;

      ProductRecommendations.prototype.connectedCallback = function () {
        var url = this.getAttribute('data-url');
        if (!url || this.hasAttribute('data-loaded') || this.hasAttribute('data-loading')) {
          return;
        }

        var self = this;

        if (!('IntersectionObserver' in window)) {
          self.load(url);
          return;
        }

        this.observer = new IntersectionObserver(
          function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                self.disconnectObserver();
                self.load(url);
                break;
              }
            }
          },
          { rootMargin: '0px 0px 400px 0px' }
        );

        this.observer.observe(this);
      };

      ProductRecommendations.prototype.disconnectedCallback = function () {
        this.disconnectObserver();
      };

      ProductRecommendations.prototype.disconnectObserver = function () {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
      };

      ProductRecommendations.prototype.load = function (url) {
        if (this.hasAttribute('data-loaded') || this.hasAttribute('data-loading')) {
          return;
        }

        var self = this;
        self.setAttribute('data-loading', '');

        fetch(url)
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Recommendations request failed: ' + response.status);
            }
            return response.text();
          })
          .then(function (text) {
            var html = new DOMParser().parseFromString(text, 'text/html');
            var fetched = html.querySelector('product-recommendations');

            self.removeAttribute('data-loading');
            self.setAttribute('data-loaded', '');

            if (fetched) {
              self.innerHTML = fetched.innerHTML;
            } else {
              // Performed-but-empty (or unexpected markup) → collapse to nothing.
              self.innerHTML = '';
            }
          })
          .catch(function () {
            // Never throw. Stop the shimmer and swap the placeholder grid for
            // a quiet one-line note, so a failed request doesn't leave an
            // endless loading animation on the page.
            self.removeAttribute('data-loading');
            self.setAttribute('data-failed', '');
            if (self.querySelector('.product-recommendations__empty')) return;
            var grid = self.querySelector('.product-recommendations__grid');
            var note = document.createElement('p');
            note.className = 'product-recommendations__empty';
            note.textContent = self.getAttribute('data-unavailable-text') || '';
            if (grid) {
              grid.replaceWith(note);
            } else {
              self.appendChild(note);
            }
          });
      };

      window.customElements.define('product-recommendations', ProductRecommendations);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    if (window.__serenSpotlightAvailability) return;
    window.__serenSpotlightAvailability = true;

    /* Keep the spotlight availability line truthful when the shopper picks
       another variant: sold-out variants read "Sold out" with the red dot. */
    document.addEventListener('theme:product:variant-change', function (e) {
      var detail = e.detail || {};
      var variant = detail.variant;
      var root = detail.root;
      if (!variant || !root || !root.querySelector) return;
      var line = root.querySelector('[data-spotlight-availability]');
      if (!line) return;
      var out = variant.available === false;
      line.textContent = out
        ? line.getAttribute('data-sold-out-text')
        : line.getAttribute('data-in-stock-text');
      line.classList.remove('is-back', 'is-low', 'is-out');
      line.classList.add(out ? 'is-out' : line.getAttribute('data-in-stock-state') || 'is-back');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Sticky ATC dark-section-aware palette: delegated to SerenDarkOverlap so
     all sticky/floating bars share one scroll loop + one scheme cache. */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    if (!bar || !window.SerenDarkOverlap) return;
    window.SerenDarkOverlap.observe(bar, { className: 'sticky-atc--on-dark' });
  })();

  /* ── Sticky ATC: sync variant name, compare-at price, image ──
     Scoped to the product root that fired the change (detail.root, set by
     theme.js setVariant) so a quick-shop dialog opened on a PDP never
     rewrites the PDP's bar. Falls back to the first product root. */
  document.addEventListener('theme:product:variant-change', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;
    var root = (e.detail && e.detail.root) || document.querySelector('[data-product]');
    if (!root || !root.querySelector('[data-sticky-atc]')) return;

    var variantEl = root.querySelector('[data-sticky-atc-variant]');
    if (variantEl) {
      variantEl.textContent = (variant.title && variant.title !== 'Default Title') ? variant.title : '';
    }

    var compareEl = root.querySelector('[data-sticky-atc-compare]');
    if (compareEl) {
      var cmpEl = root.querySelector('.product__variant-price.is-active .price__compare');
      compareEl.textContent = (cmpEl && cmpEl.textContent.trim()) ? cmpEl.textContent.trim() : '';
    }

    var imageWrap = root.querySelector('[data-sticky-atc-image]');
    if (imageWrap) {
      var img = imageWrap.querySelector('img');
      if (img && variant.featured_image && variant.featured_image.src) {
        var rawSrc = variant.featured_image.src;
        img.srcset = '';
        img.src = rawSrc.indexOf('?') > -1
          ? rawSrc.replace(/(\.\w+)\?/, '_120x$1?')
          : rawSrc.replace(/(\.\w+)$/, '_120x$1');
      }
    }
  });

  /* ── PDP Accordion: single-open + smooth animated height ───── */
  (function () {
    var DURATION = 250;
    var EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function initAccordionGroup(group) {
      if (!group || group.__pdpAccInit) return;
      group.__pdpAccInit = true;

      var items = group.querySelectorAll('[data-pdp-accordion-item]');

      function closeItem(details, animate) {
        var panel = details.querySelector('.pdp-accordion__panel');
        var summary = details.querySelector('.pdp-accordion__header');
        if (!panel) return;
        if (summary) summary.setAttribute('aria-expanded', 'false');

        if (!animate || reducedMotion.matches) {
          details.removeAttribute('open');
          return;
        }

        var h = panel.scrollHeight;
        var anim = panel.animate(
          [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
          { duration: DURATION, easing: EASING }
        );
        anim.onfinish = function () {
          details.removeAttribute('open');
          panel.style.height = '';
          panel.style.opacity = '';
        };
      }

      function openItem(details, animate) {
        var panel = details.querySelector('.pdp-accordion__panel');
        var summary = details.querySelector('.pdp-accordion__header');
        if (!panel) return;

        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');

        if (!animate || reducedMotion.matches) return;

        var h = panel.scrollHeight;
        panel.animate(
          [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
          { duration: DURATION, easing: EASING }
        );
      }

      items.forEach(function (details) {
        var summary = details.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = details.hasAttribute('open');

          if (isOpen) {
            closeItem(details, true);
          } else {
            items.forEach(function (other) {
              if (other !== details && other.hasAttribute('open')) {
                closeItem(other, true);
              }
            });
            openItem(details, true);
          }
        });
      });
    }

    document.querySelectorAll('[data-pdp-accordion]').forEach(initAccordionGroup);
    document.addEventListener('shopify:section:load', function (ev) {
      if (ev.target) ev.target.querySelectorAll('[data-pdp-accordion]').forEach(initAccordionGroup);
    });
  })();

  /* ── Quantity stepper: minus / plus buttons ─────────────────── */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('[data-product-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = 1;
    var min = parseInt(input.min, 10) || 1;
    if (minus) val = Math.max(min, val - 1);
    if (plus) val = val + 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── Clinician Choice: smooth-scroll for fragment anchors ────── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-clinician-scroll]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  /* ── Add-on tiles: standalone SerenCart add-to-cart ──────────── */
  /* window.t (theme.js, which runs before section scripts) reads #theme-strings. */
  var t = window.t;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-add]');
    if (!btn || btn.disabled || btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var variantId = parseInt(btn.getAttribute('data-addon-variant-id'), 10);
    if (isNaN(variantId)) return;

    var labelEl = btn.querySelector('[data-addon-label]');
    var originalLabel = labelEl ? labelEl.textContent : '';

    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (labelEl) labelEl.textContent = '';

    if (!window.SerenCart || typeof window.SerenCart.addToCart !== 'function') {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
      if (labelEl) labelEl.textContent = originalLabel;
      return;
    }

    window.SerenCart.addToCart(variantId, 1)
      .then(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        if (labelEl) labelEl.textContent = t('addon_added', 'Added');

        /* Open the cart drawer the same way the main ATC does so the
           merchant gets visual confirmation of the add — without this
           the cart silently updates and the customer has no signal
           that anything happened. */
        if (typeof window.openCartDrawer === 'function') {
          window.openCartDrawer(btn);
        }

        setTimeout(function () {
          btn.classList.remove('is-added');
          if (labelEl) labelEl.textContent = originalLabel;
        }, 1800);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        if (labelEl) labelEl.textContent = originalLabel;
        if (window.SerenToast) window.SerenToast.cartAddError();
      });
  });

  /* ── UGC marquee: scrollable auto-advance + grab-drag ──────────
     Follows the review-marquee scrollable-mode pattern: native
     overflow-x gives touch users swipe, rAF auto-advance provides
     the "infinite loop" feel, mouse gets grab-cursor drag. Content
     is SSR-duplicated [A][A]; normalize-at-half teleports the scroll
     position so the loop is seamless. */
  function initUgcMarquee(root) {
    if (!root || root.__ugcInit) return;
    root.__ugcInit = true;

    var viewport = root.querySelector('[data-ugc-viewport]');
    var track = root.querySelector('[data-ugc-track]');
    if (!viewport || !track || !track.children.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hoverMQ = window.matchMedia('(hover: hover)');

    var pps = parseFloat(getComputedStyle(root).getPropertyValue('--ugc-pps'));
    if (!(pps > 0)) pps = 45;

    var half = 0;
    var dragging = false;
    var hovered = false;
    var lastX = 0;
    var lastT = 0;
    var pxBank = 0;
    var rafId = 0;

    function ensureWideEnough() {
      var vw = viewport.clientWidth;
      if (!vw || track.children.length > 80) return;
      var target = vw * 2.5;
      if (track.scrollWidth >= target) return;
      var originals = Array.prototype.slice.call(track.children);
      for (var iter = 0; iter < 4 && track.scrollWidth < target; iter++) {
        var widthBefore = track.scrollWidth;
        var frag = document.createDocumentFragment();
        for (var i = 0; i < originals.length; i++) {
          var clone = originals[i].cloneNode(true);
          /* `inert` over `aria-hidden`: clones are pure visual padding for
             the infinite-scroll loop. `inert` removes them from a11y AND
             from the focus tree, which is what we actually want. Static
             aria-hidden + focusable descendants triggers the Chrome
             "descendant retained focus" warning if a SR/keyboard user
             ever lands on a clone. */
          clone.inert = true;
          frag.appendChild(clone);
        }
        var added = Array.prototype.slice.call(frag.childNodes);
        track.appendChild(frag);
        /* Hard stop: a pass that adds no width (clones hidden or
           collapsed) is undone, so this can never loop on empty copies. */
        if (track.scrollWidth <= widthBefore) {
          for (var j = 0; j < added.length; j++) track.removeChild(added[j]);
          return;
        }
      }
    }

    function normalize() {
      if (half < 1) return;
      var sl = viewport.scrollLeft;
      if (sl <= 0) viewport.scrollLeft = sl + half;
      else if (sl >= half) viewport.scrollLeft = sl - half;
    }

    function layout() {
      ensureWideEnough();
      half = track.scrollWidth / 2;
      if (half >= 1) {
        normalize();
        armRaf();
      }
    }

    function tick(ts) {
      rafId = 0;
      if (!root.isConnected) return;
      if (!lastT) lastT = ts;
      var dt = Math.min((ts - lastT) / 1000, 0.1);
      lastT = ts;

      if (!dragging && !hovered && !reducedMotion.matches && half > 0) {
        pxBank += pps * dt;
        var px = Math.floor(pxBank);
        if (px >= 1) {
          pxBank -= px;
          viewport.scrollLeft += px;
          normalize();
        }
      }
      armRaf();
    }

    function armRaf() {
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    /* Hover pause */
    function onEnter() { hovered = true; pxBank = 0; }
    function onLeave() { hovered = false; pxBank = 0; lastT = 0; armRaf(); }
    function bindHover() {
      if (!hoverMQ.matches) return;
      root.addEventListener('mouseenter', onEnter);
      root.addEventListener('mouseleave', onLeave);
    }
    function unbindHover() {
      root.removeEventListener('mouseenter', onEnter);
      root.removeEventListener('mouseleave', onLeave);
      hovered = false;
    }
    bindHover();
    if (hoverMQ.addEventListener) {
      hoverMQ.addEventListener('change', function () { unbindHover(); bindHover(); });
    }

    /* Grab-drag (mouse only — touch uses native scroll) */
    var didDrag = false;
    viewport.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragging = true;
      didDrag = false;
      lastX = e.clientX;
      pxBank = 0;
      viewport.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      didDrag = true;
      var dx = lastX - e.clientX;
      lastX = e.clientX;
      viewport.scrollLeft += dx;
      normalize();
    });
    document.addEventListener('mouseup', function () {
      if (!dragging) return;
      dragging = false;
      pxBank = 0;
      lastT = 0;
      viewport.classList.remove('is-dragging');
      armRaf();
    });

    viewport.addEventListener('click', function (e) {
      if (didDrag) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* Copies (the SSR second set and the clones above) are inert, and an
       inert tile takes no pointer events, so a click or tap on one lands on
       the track. Forward it to the original tile in the same slot, so every
       tile a visitor can see still opens its video. Copies repeat the
       originals in order, so slot i maps to original i % n. */
    viewport.addEventListener('click', function (e) {
      if (e.target !== track && e.target !== viewport) return;
      var items = track.children;
      var n = 0;
      while (n < items.length && !items[n].inert) n++;
      if (!n) return;
      for (var i = n; i < items.length; i++) {
        var r = items[i].getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
          var tile = items[i % n].querySelector('.product__ugc-marquee-tile');
          if (tile) tile.click();
          return;
        }
      }
    });

    /* Scroll listener for normalize during native touch scroll */
    viewport.addEventListener('scroll', normalize, { passive: true });

    /* Horizontal wheel */
    viewport.addEventListener('wheel', function (e) {
      var dx = e.shiftKey ? e.deltaY : e.deltaX;
      if (!dx || (!e.shiftKey && Math.abs(e.deltaX) < Math.abs(e.deltaY))) return;
      e.preventDefault();
      viewport.scrollLeft += dx;
      normalize();
    }, { passive: false });

    /* Bootstrap: multi-stage layout so we catch post-paint widths */
    layout();
    requestAnimationFrame(function () {
      layout();
      requestAnimationFrame(layout);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(layout).observe(track);
    } else {
      window.addEventListener('resize', layout, { passive: true });
    }

    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', armRaf);
  }

  document.querySelectorAll('[data-ugc-marquee]').forEach(initUgcMarquee);
  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) ev.target.querySelectorAll('[data-ugc-marquee]').forEach(initUgcMarquee);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* easeOutCubic — quick early motion that settles softly at the target,
     reads as "natural" rather than linear. Matches the easing curve used
     across the theme's transition tokens in spirit. */
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function animate(stat, delay, duration) {
    var target = parseFloat(stat.getAttribute('data-rp-value')) || 0;
    var suffix = stat.getAttribute('data-rp-suffix') || '';
    var numEl = stat.querySelector('[data-rp-num]');
    var ringEl = stat.querySelector('[data-rp-ring]');
    /* Clamp for the stroke-dashoffset math; the text can still display
       the raw merchant value (e.g. for stats that intentionally show
       something above 100 or negative). */
    var clamped = Math.max(0, Math.min(100, target));

    window.setTimeout(function () {
      if (ringEl) {
        ringEl.style.strokeDashoffset = (100 - clamped).toFixed(2);
      }
      if (!numEl) return;

      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        var v = target * easeOutCubic(p);
        numEl.textContent = Math.round(v) + suffix;
        if (p < 1) {
          window.requestAnimationFrame(step);
        } else {
          numEl.textContent = Math.round(target) + suffix;
        }
      }
      window.requestAnimationFrame(step);
    }, delay);
  }

  /* Jump-to-target for reduced-motion + no-IntersectionObserver fallback —
     show the final visible state without any animation. */
  function jumpTo(stat) {
    var target = parseFloat(stat.getAttribute('data-rp-value')) || 0;
    var suffix = stat.getAttribute('data-rp-suffix') || '';
    var numEl = stat.querySelector('[data-rp-num]');
    var ringEl = stat.querySelector('[data-rp-ring]');
    var clamped = Math.max(0, Math.min(100, target));

    if (ringEl) {
      /* Kill the transition for this frame so the ring snaps instead
         of gliding in — feels wrong when the rest of the page is still. */
      ringEl.style.transition = 'none';
      ringEl.style.strokeDashoffset = (100 - clamped).toFixed(2);
    }
    if (numEl) numEl.textContent = Math.round(target) + suffix;
  }

  /* Read a ms duration from a CSS custom property on the root. Accepts
     values in `ms` or `s`; falls back to the provided default on parse
     failure or if the prop is empty. Used to keep the count-up rAF loop
     in sync with the CSS transition on .rp__ring-fill. */
  function readDuration(root, prop, fallback) {
    var raw = window.getComputedStyle(root).getPropertyValue(prop).trim();
    if (!raw) return fallback;
    var m = raw.match(/^(-?\d*\.?\d+)(ms|s)?$/);
    if (!m) return fallback;
    var n = parseFloat(m[1]);
    if (isNaN(n)) return fallback;
    return m[2] === 's' ? n * 1000 : n;
  }

  function init(root) {
    if (!root || root.__rpInit) return;
    root.__rpInit = true;

    var stats = root.querySelectorAll('[data-rp-stat]');
    if (!stats.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !('IntersectionObserver' in window)) {
      stats.forEach(jumpTo);
      return;
    }

    /* Stagger + duration tuned so three rows take about 1.7s end-to-end —
       fast enough to feel intentional, slow enough to read the count-up.
       DURATION reads from the --rp-count-duration CSS custom property so
       the ring transition and the number rAF loop stay in lockstep. */
    var STAGGER = 150;
    var DURATION = readDuration(root, '--rp-count-duration', 1400);

    /* Once-triggered: as soon as the list enters the viewport we disconnect
       the observer. Users shouldn't see the animation replay every time
       they scroll past — it reads as gimmicky. */
    var obs = new IntersectionObserver(function (entries, o) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        o.unobserve(entry.target);
        stats.forEach(function (s, i) {
          animate(s, i * STAGGER, DURATION);
        });
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

    obs.observe(root);
    root.__rpObs = obs;
  }

  function teardown(root) {
    if (!root || !root.__rpObs) return;
    root.__rpObs.disconnect();
    root.__rpObs = null;
    root.__rpInit = false;
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rp-stats]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    if (ev.target) {
      ev.target.querySelectorAll('[data-rp-stats]').forEach(teardown);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-marquee"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Non-scrollable mode: CSS transform animation drives motion (smooth,
     GPU-composited). Scrollable mode: JS drives scrollLeft with an integer-
     pixel accumulator (jitter-free on native scroll containers) and the
     seamless [A][A] normalize-at-half pattern for bidirectional infinite
     scroll. Hover pause is only bound on `(hover: hover)` devices so the
     sticky-hover state on mobile can't strand the track paused after a tap. */

  function init(root) {
    if (!root || root.__rmInit) return;
    root.__rmInit = true;

    var viewport = root.querySelector('.review-marquee__viewport');
    var track = root.querySelector('[data-rm-track]');
    if (!viewport || !track) return;
    if (!track.children.length) return;

    var isScrollable = root.classList.contains('review-marquee--scrollable');
    var hasPauseHover = root.classList.contains('review-marquee--pause-hover');
    var reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hoverMQ = window.matchMedia('(hover: hover)');

    /* Copy ceiling for ensureWideEnough(): the track never holds more
       than 32× the server-rendered children (SSR [A][A] → at most 64
       copies of the card set, the old single-call ceiling). */
    var maxTrackChildren = track.children.length * 32;

    var videoObserver = null;

    /* ── Video playback (shared by both modes) ──────────────────── */
    function wireVideos() {
      var videos = track.querySelectorAll('video');
      if (!videos.length || !('IntersectionObserver' in window)) return;
      if (!videoObserver) {
        videoObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var v = entry.target;
              if (entry.isIntersecting) {
                if (v.preload === 'none') v.preload = 'metadata';
                var p = v.play();
                if (p && typeof p.catch === 'function') p.catch(function () {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          isScrollable
            ? { root: viewport, rootMargin: '0px 25% 0px 25%', threshold: 0.01 }
            : { rootMargin: '10% 0px', threshold: 0.01 }
        );
      }
      videos.forEach(function (v) {
        if (v.__rmObserved) return;
        v.__rmObserved = true;
        videoObserver.observe(v);
      });
    }

    /* Half-set offset — pixel distance from the track's left edge to
       the first item of the SSR duplicate set. Used by BOTH modes
       (CSS-driven and JS-driven) as the loop target. Computed via the
       browser's layout (offsetLeft) so no browser-specific scrollWidth
       / max-content quirks can throw it off — mirrors how
       scrolling-strip.liquid resolves --strip-track-translate.

       Assumes children come in N matched pairs (original + duplicate),
       i.e. children.length is even and the first half is identical to
       the second. The SSR + ensureWideEnough() cloning both preserve
       this invariant: SSR emits [A][A], and ensureWideEnough() clones
       the WHOLE existing children array at once, so the count always
       stays even and pair-symmetric (12 → 24 → 48 …). */
    function measureHalfOffset() {
      var children = track.children;
      var n = children.length;
      if (n < 2) return 0;
      var halfIndex = Math.floor(n / 2);
      var halfChild = children[halfIndex];
      return halfChild ? halfChild.offsetLeft : 0;
    }

    /* ── Content-width safety (shared by both modes) ───────────────
       The SSR ships [A][A] (one set + duplicate). On a wide viewport
       (1440p / ultrawide) or with a narrow card set that can fall short
       of `viewport + half`, so the loop shows empty space past the track
       tail. Clone the WHOLE children list (doubling 12 → 24 → 48 …,
       keeping the pair symmetry measureHalfOffset() relies on) until the
       track is 2.25× the viewport.

       Hard bounds — this runs on every layout pass (rAF, fonts, load,
       timeout, resize, ResizeObserver), so it must never be able to
       grow without limit:
       - Reduced motion: the marquee is static and the duplicates are
         hidden (display: none), so never clone at all. Clones there add
         no width, and doubling until wide would never terminate.
       - At most 5 doublings per call, and never past maxTrackChildren.
       - A pass that adds no width (clones hidden or collapsed) is
         undone and widening stops for this call. */
    function ensureWideEnough() {
      if (reducedMotionMQ.matches) return;
      var vw = viewport.clientWidth;
      if (!vw) return;
      var target = vw * 2.25; /* safety margin over `viewport + half` */
      for (var iter = 0; iter < 5 && track.scrollWidth < target; iter++) {
        var existing = Array.prototype.slice.call(track.children);
        if (!existing.length || existing.length * 2 > maxTrackChildren) return;
        var widthBefore = track.scrollWidth;
        var added = [];
        for (var i = 0; i < existing.length; i++) {
          /* Clones are visual filler: inert keeps their links / play
             buttons out of the tab order and the accessibility tree. */
          var clone = existing[i].cloneNode(true);
          clone.setAttribute('inert', '');
          track.appendChild(clone);
          added.push(clone);
        }
        if (track.scrollWidth <= widthBefore) {
          for (var j = 0; j < added.length; j++) track.removeChild(added[j]);
          return;
        }
      }
    }

    /* ======================================================== */
    /*  NON-SCROLLABLE MODE — CSS animation + JS-toggled pause   */
    /* ======================================================== */
    if (!isScrollable) {
      /* A track narrower than `viewport + halfW` reveals empty space
         past its tail when the animation translates by halfW (the
         "blank pause" once mistaken for a loop-alignment bug).
         ensureWideEnough() above widens it. */
      function staticLayout() {
        /* Track is N× content (SSR-duplicated [A][A] plus any further
           clones from ensureWideEnough above). halfW = pixel
           offset to the child at children.length/2, which is the start
           of the second pair-symmetric half — see measureHalfOffset()
           for why offsetLeft beats scrollWidth/2 on browsers with
           inconsistent trailing-margin handling.

           Setting --rm-shift on the track parameterises the CSS keyframe
           (review-marquee-scroll) which translates by exactly that
           value; the animation has to be restarted so the new shift
           takes effect on the next cycle (custom-property values in
           keyframe at-rules are resolved at animation start, not on
           every frame). */
        ensureWideEnough();

        var halfW = measureHalfOffset();
        if (!halfW) return;

        var pps = parseFloat(window.getComputedStyle(root).getPropertyValue('--rm-speed-pps'));
        track.style.setProperty('--rm-shift', halfW.toFixed(2) + 'px');
        if (pps > 0) {
          track.style.setProperty('--rm-duration', (halfW / pps).toFixed(2) + 's');
        }

        /* Restart the animation so the new --rm-shift takes effect. */
        track.style.animation = 'none';
        /* Force reflow so the reset is committed before re-applying. */
        void track.offsetWidth;
        track.style.animation = '';

        wireVideos();
      }

      var staticResizeTimer = null;
      function onStaticResize() {
        if (staticResizeTimer) window.clearTimeout(staticResizeTimer);
        staticResizeTimer = window.setTimeout(staticLayout, 150);
      }

      /* Hover pause — bound only on hover-capable devices so mobile's
         sticky :hover after a tap can't freeze the marquee. */
      function onHoverEnter() { root.classList.add('is-paused'); track.style.animationPlayState = 'paused'; }
      function onHoverLeave() { root.classList.remove('is-paused'); track.style.animationPlayState = ''; }

      function bindHover() {
        if (!hasPauseHover || !hoverMQ.matches) return;
        root.addEventListener('mouseenter', onHoverEnter);
        root.addEventListener('mouseleave', onHoverLeave);
        root.addEventListener('focusin', onHoverEnter);
        root.addEventListener('focusout', onHoverLeave);
      }
      function unbindHover() {
        root.removeEventListener('mouseenter', onHoverEnter);
        root.removeEventListener('mouseleave', onHoverLeave);
        root.removeEventListener('focusin', onHoverEnter);
        root.removeEventListener('focusout', onHoverLeave);
      }
      bindHover();

      function onHoverCapChange() {
        unbindHover();
        onHoverLeave();
        bindHover();
      }
      if (hoverMQ.addEventListener) hoverMQ.addEventListener('change', onHoverCapChange);
      /* Motion switched back on: widen + restart the loop. */
      if (reducedMotionMQ.addEventListener) reducedMotionMQ.addEventListener('change', staticLayout);

      window.addEventListener('resize', onStaticResize, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(staticLayout);
      staticLayout();

      root.__rmTeardown = function () {
        unbindHover();
        window.removeEventListener('resize', onStaticResize);
        if (hoverMQ.removeEventListener) hoverMQ.removeEventListener('change', onHoverCapChange);
        if (reducedMotionMQ.removeEventListener) reducedMotionMQ.removeEventListener('change', staticLayout);
        if (staticResizeTimer) window.clearTimeout(staticResizeTimer);
        if (videoObserver) { videoObserver.disconnect(); videoObserver = null; }
        root.__rmInit = false;
      };
      return;
    }

    /* ============================================================
     *  SCROLLABLE MODE
     *  Native scroll container + rAF-driven auto-advance with a
     *  seamless [A][A] normalize-at-half loop. Mouse gets grab-drag;
     *  touch gets native scroll + momentum + proximity snap (mobile
     *  CSS). Auto-advance pauses on hover (desktop only, hover-cap
     *  gated) and on drag. Wheel handled for desktop horizontal pan.
     * ============================================================ */

    /* One-time inputs: speed and media queries are constant for the
       section's lifetime. Cache them so the hot path (tick) never
       calls getComputedStyle or matchMedia. */
    var pps = parseFloat(window.getComputedStyle(root).getPropertyValue('--rm-speed-pps'));
    if (!(pps > 0)) pps = 55;

    /* State ------------------------------------------------------ */
    var half = 0;              // width of one [A] set; wrap anchor
    var dragging = false;      // mouse drag in progress
    var hovered = false;       // desktop cursor over section
    var inView = true;         // section intersects viewport (approx)
    var lastPointerX = 0;
    var lastTickTime = 0;
    var pxBank = 0;            // sub-pixel accumulator → integer writes
    var rafScheduled = false;

    /* The [A][A] pattern needs `half` < `trackWidth − viewportWidth`;
       ensureWideEnough() (shared, above) widens narrow card sets. */

    /* ── Seamless wrap ────────────────────────────────────────────
       Track = [A][A] of identical content. scrollLeft = 0 and = half
       render identically, so we teleport between them when approaching
       either end. The extra +/- half buffer means a whole frame's
       advance can't overshoot past the other side's wrap zone. */
    function normalize() {
      if (half < 1) return;
      var sl = viewport.scrollLeft;
      if (sl <= 0) {
        viewport.scrollLeft = sl + half;
      } else if (sl > half) {
        /* Single assignment — browsers don't batch while-loops, and
           a single large delta here is safe when content > 2×viewport. */
        viewport.scrollLeft = sl - half;
      }
    }

    /* Combined measure + width-check, called from every stage that
       could shift layout. `armRaf` kicks the loop back to life if it
       had gone idle waiting for a valid half. Half is the offsetLeft
       of the duplicate set's first item — see measureHalfOffset()
       earlier. The previous `track.scrollWidth / 2` was off by half a
       gap on browsers that excluded the trailing flex-item margin
       from scrollWidth; the offsetLeft path is byte-exact. */
    function layout() {
      ensureWideEnough();
      half = measureHalfOffset();
      if (half >= 1) {
        normalize();
        armRaf();
      }
    }

    /* ── rAF loop ─────────────────────────────────────────────────
       Runs only when motion is needed. Integer-pixel writes (floor
       of accumulated sub-pixels) avoid jitter on native scroll
       containers that round scrollLeft to integers anyway. dt clamp
       prevents a huge jump after the tab was backgrounded. */
    function armRaf() {
      if (rafScheduled) return;
      rafScheduled = true;
      window.requestAnimationFrame(tick);
    }

    function tick(ts) {
      rafScheduled = false;
      if (!root.isConnected) return;

      if (!lastTickTime) lastTickTime = ts;
      var dt = Math.min((ts - lastTickTime) / 1000, 0.1);
      lastTickTime = ts;

      var shouldAdvance =
        inView && !reducedMotionMQ.matches && !dragging && !hovered && half >= 1;

      if (shouldAdvance) {
        pxBank += pps * dt;
        if (pxBank >= 1) {
          var step = Math.floor(pxBank);
          pxBank -= step;
          viewport.scrollLeft += step;
          normalize();
        }
        rafScheduled = true;
        window.requestAnimationFrame(tick);
      } else if (!inView) {
        /* Keep time baseline fresh so the next armRaf doesn't see a
           huge dt (which would be clamped but still feel sluggish). */
        lastTickTime = ts;
      }
    }

    /* ── Layout bootstrap ────────────────────────────────────────
       viewport.clientWidth may be 0 before first paint, so we call
       layout() at each stable point. Cheap; ensureWideEnough() early-
       outs on a vw of 0 or once the track is wide enough. */
    layout();
    window.requestAnimationFrame(function () {
      layout();
      window.requestAnimationFrame(layout);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout);
    window.setTimeout(layout, 500);

    /* ── Responders to layout changes ─────────────────────────── */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(layout).observe(track);
    } else {
      window.addEventListener('resize', layout, { passive: true });
    }

    /* Skip work when the section is off-screen. 80px margin starts
       the loop just before the user scrolls the section into view. */
    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        inView = entries[0] ? entries[0].isIntersecting : true;
        if (inView) lastTickTime = 0;
        armRaf();
      }, { root: null, rootMargin: '80px 0px', threshold: 0 }).observe(root);
    }

    viewport.addEventListener('scroll', normalize, { passive: true });

    /* ── Desktop hover pause ─────────────────────────────────────
       Gated on (hover: hover) so mobile's sticky :hover after a tap
       can never strand the rail paused. */
    viewport.addEventListener('mouseenter', function () {
      if (!hasPauseHover || !hoverMQ.matches) return;
      hovered = true;
      pxBank = 0;
    });
    viewport.addEventListener('mouseleave', function () {
      if (!hasPauseHover || !hoverMQ.matches) return;
      hovered = false;
      pxBank = 0;
      lastTickTime = 0;
      armRaf();
    });

    /* Re-evaluate hover + motion prefs if they change live (DevTools,
       browser settings toggles, plugging in a mouse on a tablet). */
    /* layout() re-runs ensureWideEnough (skipped while reduced) and
       re-measures half (0 while the duplicates are hidden). */
    if (reducedMotionMQ.addEventListener) {
      reducedMotionMQ.addEventListener('change', function () {
        layout();
        armRaf();
      });
    }
    if (hoverMQ.addEventListener) {
      hoverMQ.addEventListener('change', function () {
        hovered = false;
        armRaf();
      });
    }

    /* ── Mouse-only drag ─────────────────────────────────────────
       Touch stays with native scroll → real momentum + snap. Mouse
       drags set scrollLeft directly; native scroll event fires after,
       which normalize()s if we cross half. pointerType guard is key. */
    function onPointerDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('[data-video-modal]')) return;
      dragging = true;
      pxBank = 0;
      lastPointerX = e.clientX;
      root.classList.add('review-marquee--grabbing');
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    }
    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - lastPointerX;
      lastPointerX = e.clientX;
      viewport.scrollLeft -= dx;
      normalize();
    }
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      pxBank = 0;
      lastTickTime = 0;
      root.classList.remove('review-marquee--grabbing');
      armRaf();
      try { if (e && e.pointerId != null) viewport.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    viewport.addEventListener('pointerdown', onPointerDown, true);
    viewport.addEventListener('pointermove', onPointerMove, true);
    viewport.addEventListener('pointerup', endDrag, true);
    viewport.addEventListener('pointercancel', endDrag, true);
    viewport.addEventListener('lostpointercapture', endDrag);

    /* ── Desktop horizontal wheel ────────────────────────────────
       Trackpad two-finger horizontal swipe gives a deltaX directly;
       shift+wheel on a mouse maps deltaY → horizontal. Only consume
       events where horizontal delta dominates, otherwise vertical
       page scroll still works when the cursor is over the marquee. */
    viewport.addEventListener('wheel', function (e) {
      var dx = e.shiftKey ? e.deltaY : e.deltaX;
      if (!dx || (!e.shiftKey && Math.abs(e.deltaX) < Math.abs(e.deltaY))) return;
      e.preventDefault();
      viewport.scrollLeft += dx;
      normalize();
    }, { passive: false });

    /* Start the loop. It'll decide per-frame whether to advance. */
    armRaf();

    root.__rmTeardown = function () {
      if (videoObserver) { videoObserver.disconnect(); videoObserver = null; }
      root.__rmInit = false;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-review-marquee]').forEach(init);
  }

  function teardownAll(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-review-marquee]').forEach(function (root) {
      if (typeof root.__rmTeardown === 'function') root.__rmTeardown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    if (ev.target) teardownAll(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-strip"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* Non-scrollable: CSS transform animation (smooth, GPU-composited).
     Scrollable: JS-driven scrollLeft with an integer-pixel accumulator
     and the seamless [A][A] normalize-at-half pattern for bidirectional
     infinite scroll. Hover pause only binds on `(hover: hover)` so the
     mobile sticky-hover after a tap can't freeze the strip. */

  function init(strip) {
    if (!strip || strip.__stripInit) return;
    strip.__stripInit = true;

    var viewport = strip.querySelector('.scrolling-strip__viewport');
    var track = strip.querySelector('[data-scrolling-strip-track]');
    if (!viewport || !track) return;

    var baseSegments = Array.prototype.slice.call(
      track.querySelectorAll('[data-scrolling-strip-segment]')
    );
    if (baseSegments.length < 2) return;

    for (var i = 1; i < baseSegments.length; i++) {
      /* `inert` over `aria-hidden`: segments contain focusable links;
         aria-hidden over a focused descendant warns. */
      baseSegments[i].inert = true;
    }

    var isScrollable = strip.classList.contains('scrolling-strip--scrollable');
    var hasPauseHover = strip.classList.contains('scrolling-strip--pause-hover');
    var reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hoverMQ = window.matchMedia('(hover: hover)');

    /* Visible pause / play control (WCAG 2.2.2). `userPaused` wins over the
       hover resume in both modes. */
    var userPaused = false;
    var pauseBtn = strip.querySelector('[data-scrolling-strip-pause]');
    function syncPauseButton() {
      if (!pauseBtn) return;
      pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      var label = pauseBtn.getAttribute(userPaused ? 'data-label-play' : 'data-label-pause');
      if (label) pauseBtn.setAttribute('aria-label', label);
      strip.classList.toggle('is-user-paused', userPaused);
    }

    /* Copy ceiling for the scrollable ensureWideEnough(): never more
       than 32× the server-rendered segments (the old single-call
       ceiling of 5 doublings). */
    var maxTrackChildren = track.children.length * 32;

    /* ======================================================== */
    /*  NON-SCROLLABLE MODE — CSS animation + JS-toggled pause   */
    /* ======================================================== */
    if (!isScrollable) {
      function staticLayout() {
        var segWidth = baseSegments[0].offsetWidth || baseSegments[0].scrollWidth || 0;
        if (!segWidth) return;

        /* Seamless-loop guarantee: the CSS keyframe translates the track
           by exactly one segment width on each cycle. For the right edge
           of the viewport to never reveal "past the last segment" during
           that translate, total track width must be at least viewport +
           one segment. The SSR ships [A][A] (two segments) — fine when
           segWidth ≥ viewport, but with short content sets (few items,
           narrow text) the two segments don't reach the viewport edge
           and a gap appears before each loop restart. Clone more copies
           until we have enough cushion. Capped so a degenerate one-item
           segment can't flood the DOM. */
        var vw = viewport.clientWidth;
        /* Reduced motion: the strip is static and copies are hidden, so
           cloning adds nothing. */
        if (vw > 0 && !reducedMotionMQ.matches) {
          var needed = Math.min(20, Math.max(2, Math.ceil((vw + segWidth) / segWidth)));
          var existing = track.querySelectorAll('[data-scrolling-strip-segment]').length;
          for (var i = existing; i < needed; i++) {
            var clone = baseSegments[0].cloneNode(true);
            clone.inert = true;
            track.appendChild(clone);
          }
        }

        /* Translate by exactly one segment width (pixel value) instead
           of `-50%`. The percentage only loops cleanly when the track
           contains exactly two segments — once JS clones in more, -50%
           shifts by half the new total, which is multiple segments and
           leaves a visible jump. Restart the animation so the new
           keyframe value takes effect (custom-property values in
           keyframe rules are resolved when the animation begins, not
           re-evaluated per frame across all browsers). */
        track.style.animation = 'none';
        /* force reflow so the animation restarts cleanly */
        void track.offsetWidth;
        track.style.setProperty('--strip-track-translate', '-' + segWidth.toFixed(2) + 'px');
        var pps = parseFloat(window.getComputedStyle(strip).getPropertyValue('--strip-speed-pps'));
        if (pps > 0) {
          track.style.setProperty('--strip-duration', (segWidth / pps).toFixed(2) + 's');
        }
        track.style.animation = '';
      }

      var staticResizeTimer = null;
      function onStaticResize() {
        if (staticResizeTimer) window.clearTimeout(staticResizeTimer);
        staticResizeTimer = window.setTimeout(staticLayout, 150);
      }

      function onHoverEnter() { strip.classList.add('is-paused'); track.style.animationPlayState = 'paused'; }
      function onHoverLeave() {
        strip.classList.remove('is-paused');
        track.style.animationPlayState = userPaused ? 'paused' : '';
      }

      function onPauseClick() {
        userPaused = !userPaused;
        track.style.animationPlayState = userPaused ? 'paused' : '';
        syncPauseButton();
      }
      if (pauseBtn) pauseBtn.addEventListener('click', onPauseClick);

      function bindHover() {
        if (!hasPauseHover || !hoverMQ.matches) return;
        strip.addEventListener('mouseenter', onHoverEnter);
        strip.addEventListener('mouseleave', onHoverLeave);
        strip.addEventListener('focusin', onHoverEnter);
        strip.addEventListener('focusout', onHoverLeave);
      }
      function unbindHover() {
        strip.removeEventListener('mouseenter', onHoverEnter);
        strip.removeEventListener('mouseleave', onHoverLeave);
        strip.removeEventListener('focusin', onHoverEnter);
        strip.removeEventListener('focusout', onHoverLeave);
      }
      bindHover();

      function onHoverCapChange() { unbindHover(); onHoverLeave(); bindHover(); }
      if (hoverMQ.addEventListener) hoverMQ.addEventListener('change', onHoverCapChange);
      /* Motion switched back on: add the copies + restart the loop. */
      if (reducedMotionMQ.addEventListener) reducedMotionMQ.addEventListener('change', staticLayout);

      window.addEventListener('resize', onStaticResize, { passive: true });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(staticLayout);
      staticLayout();

      strip.__stripTeardown = function () {
        unbindHover();
        if (pauseBtn) pauseBtn.removeEventListener('click', onPauseClick);
        window.removeEventListener('resize', onStaticResize);
        if (hoverMQ.removeEventListener) hoverMQ.removeEventListener('change', onHoverCapChange);
        if (reducedMotionMQ.removeEventListener) reducedMotionMQ.removeEventListener('change', staticLayout);
        if (staticResizeTimer) window.clearTimeout(staticResizeTimer);
        strip.__stripInit = false;
      };
      return;
    }

    /* ============================================================
     *  SCROLLABLE MODE — mirrors review-marquee's design:
     *  native scroll + rAF auto-advance + [A][A] normalize-at-half.
     *  Mouse gets grab-drag; touch gets native scroll + momentum.
     *  ============================================================ */

    var pps = parseFloat(window.getComputedStyle(strip).getPropertyValue('--strip-speed-pps'));
    if (!(pps > 0)) pps = 60;

    var half = 0;
    var dragging = false;
    var hovered = false;
    var inView = true;
    var lastPointerX = 0;
    var lastTickTime = 0;
    var pxBank = 0;
    var rafScheduled = false;

    /* Doubles the track until it is 2.25× the viewport. Runs on every
       layout pass, so it is hard-bounded (same rules as review-marquee):
       - Reduced motion: the strip is static and copies are hidden
         (display: none) — never clone; doubling until wide would never
         terminate because hidden copies add no width.
       - At most 5 doublings per call, never past maxTrackChildren.
       - A pass that adds no width is undone and widening stops. */
    function ensureWideEnough() {
      if (reducedMotionMQ.matches) return;
      var vw = viewport.clientWidth;
      if (!vw) return;
      var target = vw * 2.25;
      for (var iter = 0; iter < 5 && track.scrollWidth < target; iter++) {
        var existing = Array.prototype.slice.call(track.children);
        if (!existing.length || existing.length * 2 > maxTrackChildren) return;
        var widthBefore = track.scrollWidth;
        var added = [];
        for (var i = 0; i < existing.length; i++) {
          var clone = existing[i].cloneNode(true);
          clone.setAttribute('inert', '');
          track.appendChild(clone);
          added.push(clone);
        }
        if (track.scrollWidth <= widthBefore) {
          for (var j = 0; j < added.length; j++) track.removeChild(added[j]);
          return;
        }
      }
    }

    function normalize() {
      if (half < 1) return;
      var sl = viewport.scrollLeft;
      if (sl <= 0) {
        viewport.scrollLeft = sl + half;
      } else if (sl > half) {
        viewport.scrollLeft = sl - half;
      }
    }

    function layout() {
      ensureWideEnough();
      /* Reduced motion: no loop, so no wrap anchor (a half-width anchor
         would snap a manual swipe back). */
      half = reducedMotionMQ.matches ? 0 : track.scrollWidth / 2;
      if (half >= 1) {
        normalize();
        armRaf();
      }
    }

    function armRaf() {
      if (rafScheduled) return;
      rafScheduled = true;
      window.requestAnimationFrame(tick);
    }

    function tick(ts) {
      rafScheduled = false;
      if (!strip.isConnected) return;

      if (!lastTickTime) lastTickTime = ts;
      var dt = Math.min((ts - lastTickTime) / 1000, 0.1);
      lastTickTime = ts;

      var shouldAdvance =
        inView && !reducedMotionMQ.matches && !dragging && !hovered && !userPaused && half >= 1;

      if (shouldAdvance) {
        pxBank += pps * dt;
        if (pxBank >= 1) {
          var step = Math.floor(pxBank);
          pxBank -= step;
          viewport.scrollLeft += step;
          normalize();
        }
        rafScheduled = true;
        window.requestAnimationFrame(tick);
      } else if (!inView) {
        lastTickTime = ts;
      }
    }

    layout();
    window.requestAnimationFrame(function () {
      layout();
      window.requestAnimationFrame(layout);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
    window.addEventListener('load', layout);
    window.setTimeout(layout, 500);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(layout).observe(track);
    } else {
      window.addEventListener('resize', layout, { passive: true });
    }

    if (typeof IntersectionObserver !== 'undefined') {
      new IntersectionObserver(function (entries) {
        inView = entries[0] ? entries[0].isIntersecting : true;
        if (inView) lastTickTime = 0;
        armRaf();
      }, { root: null, rootMargin: '80px 0px', threshold: 0 }).observe(strip);
    }

    viewport.addEventListener('scroll', normalize, { passive: true });

    viewport.addEventListener('mouseenter', function () {
      if (!hasPauseHover || !hoverMQ.matches) return;
      hovered = true;
      pxBank = 0;
    });
    viewport.addEventListener('mouseleave', function () {
      if (!hasPauseHover || !hoverMQ.matches) return;
      hovered = false;
      pxBank = 0;
      lastTickTime = 0;
      armRaf();
    });

    /* layout() re-runs ensureWideEnough (skipped while reduced). */
    if (reducedMotionMQ.addEventListener) {
      reducedMotionMQ.addEventListener('change', function () {
        layout();
        armRaf();
      });
    }
    if (hoverMQ.addEventListener) {
      hoverMQ.addEventListener('change', function () {
        hovered = false;
        armRaf();
      });
    }

    function onPointerDown(e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('a, button, [data-video-modal]')) return;
      dragging = true;
      pxBank = 0;
      lastPointerX = e.clientX;
      strip.classList.add('scrolling-strip--grabbing');
      try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
    }
    function onPointerMove(e) {
      if (!dragging) return;
      var dx = e.clientX - lastPointerX;
      lastPointerX = e.clientX;
      viewport.scrollLeft -= dx;
      normalize();
    }
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      pxBank = 0;
      lastTickTime = 0;
      strip.classList.remove('scrolling-strip--grabbing');
      armRaf();
      try { if (e && e.pointerId != null) viewport.releasePointerCapture(e.pointerId); } catch (err) {}
    }
    viewport.addEventListener('pointerdown', onPointerDown, true);
    viewport.addEventListener('pointermove', onPointerMove, true);
    viewport.addEventListener('pointerup', endDrag, true);
    viewport.addEventListener('pointercancel', endDrag, true);
    viewport.addEventListener('lostpointercapture', endDrag);

    viewport.addEventListener('wheel', function (e) {
      var dx = e.shiftKey ? e.deltaY : e.deltaX;
      if (!dx || (!e.shiftKey && Math.abs(e.deltaX) < Math.abs(e.deltaY))) return;
      e.preventDefault();
      viewport.scrollLeft += dx;
      normalize();
    }, { passive: false });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pxBank = 0;
        lastTickTime = 0;
        syncPauseButton();
        armRaf();
      });
    }

    armRaf();

    strip.__stripTeardown = function () {
      strip.__stripInit = false;
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-scrolling-strip]').forEach(init);
  }

  function teardownAll(scope) {
    if (!scope) return;
    scope.querySelectorAll('[data-scrolling-strip]').forEach(function (strip) {
      if (typeof strip.__stripTeardown === 'function') strip.__stripTeardown();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    if (ev.target) teardownAll(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function activateTab(root, key) {
    var tabs = root.querySelectorAll('[data-support-hub-tab]');
    var panels = root.querySelectorAll('[data-support-hub-panel]');

    tabs.forEach(function (tab) {
      var on = tab.getAttribute('data-tab-key') === key;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var on = panel.getAttribute('data-tab-key') === key;
      panel.classList.toggle('is-active', on);
    });
  }

  // The tab whose form was actually submitted. After a successful contact submit,
  // Shopify redirects with the submitted form's id as the URL fragment
  // (#SupportHubForm-<tabKey>) — the ONLY reliable signal, since form.posted_successfully?
  // is page-level (true for EVERY form on the page). Returns the key only if it matches
  // a tab in THIS hub, else null.
  function submittedTabKey(root) {
    var hash = window.location.hash || '';
    var prefix = '#SupportHubForm-';
    if (hash.indexOf(prefix) !== 0) return null;
    var key = hash.slice(prefix.length);
    var tabs = root.querySelectorAll('[data-support-hub-tab]');
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].getAttribute('data-tab-key') === key) return key;
    }
    return null;
  }

  function readInitialTab(root) {
    // The submitted tab (if any) wins, so the success message shows on the right tab.
    var submitted = submittedTabKey(root);
    if (submitted) return submitted;
    var cfg = root.querySelector('[data-support-hub-init]');
    if (cfg) {
      try {
        var data = JSON.parse(cfg.textContent);
        if (data && data.initialTab) return data.initialTab;
      } catch (e) { /* ignore */ }
    }
    var first = root.querySelector('[data-support-hub-tab]');
    return first ? first.getAttribute('data-tab-key') : null;
  }

  // form.posted_successfully? renders the success block into EVERY tab's form. Once we
  // know which tab was actually submitted (the fragment), strip the success block from
  // all the others so they don't falsely read as submitted when the shopper clicks them.
  function pruneStaleSuccess(root) {
    var submitted = submittedTabKey(root);
    if (!submitted) return;
    root.querySelectorAll('[data-support-hub-panel]').forEach(function (panel) {
      if (panel.getAttribute('data-tab-key') === submitted) return;
      var ok = panel.querySelector('.support-hub__success');
      if (ok && ok.parentNode) ok.parentNode.removeChild(ok);
    });
  }

  function bind(root) {
    if (!root || root.getAttribute('data-support-hub-init-bound') === 'true') return;
    root.setAttribute('data-support-hub-init-bound', 'true');

    // Unhide all panels — the `hidden` attribute is a pre-JS guard so
    // Liquid-rendered success/error content stays out of the paint flow
    // until the right tab is activated.
    root.querySelectorAll('[data-support-hub-panel]').forEach(function (panel) {
      panel.removeAttribute('hidden');
    });

    pruneStaleSuccess(root);

    var initial = readInitialTab(root);
    if (initial) activateTab(root, initial);

    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-support-hub-tab]');
      if (!tab || !root.contains(tab)) return;
      var key = tab.getAttribute('data-tab-key');
      if (!key) return;
      activateTab(root, key);
      tab.focus();
    });

    root.addEventListener('keydown', function (e) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-support-hub-tab]'));
      if (tabs.length === 0) return;
      var current = document.activeElement;
      var ix = tabs.indexOf(current);
      if (ix < 0) return;

      var next = ix;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        next = (ix + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        next = (ix - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        next = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        next = tabs.length - 1;
      } else {
        return;
      }

      var key = tabs[next].getAttribute('data-tab-key');
      if (key) {
        activateTab(root, key);
        tabs[next].focus();
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-support-hub]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgency-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function pad(n) {
    return String(Math.max(0, Math.floor(n))).padStart(2, '0');
  }

  function parseConfig(sectionId) {
    var el = document.getElementById('UrgencyBannerConfig-' + sectionId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /**
   * Recurring reset for daily_reset mode. Anchors to today's local
   * `anchorHour` and counts in `intervalHours` steps from there.
   * Example: intervalHours=6, anchorHour=0 → boundaries at 00, 06, 12, 18.
   */
  function nextResetMs(intervalHours, anchorHour) {
    var intervalMs = intervalHours * 3600000;
    var now = Date.now();
    var anchor = new Date();
    anchor.setHours(anchorHour, 0, 0, 0);
    if (anchor.getTime() > now) anchor.setDate(anchor.getDate() - 1);
    var elapsed = now - anchor.getTime();
    return anchor.getTime() + (Math.floor(elapsed / intervalMs) + 1) * intervalMs;
  }

  /**
   * Campaign mode: parse `YYYY-MM-DDTHH:mm` (or `YYYY-MM-DD HH:mm`) as
   * the visitor's local time. Returns ms-since-epoch or NaN.
   */
  function parseEndAt(str) {
    if (!str) return NaN;
    return Date.parse(String(str).trim().replace(' ', 'T'));
  }

  function hide(root) {
    var section = root.closest('.urgency-banner-section');
    if (section) section.style.display = 'none';
    stopTimer(root);
  }

  function showExpired(root, message) {
    var inner = root.querySelector('.urgency-banner__inner');
    if (!inner) return;
    var timer = inner.querySelector('[data-urgency-timer]');
    if (timer) timer.remove();
    var cta = inner.querySelector('.urgency-banner__cta');
    if (cta) cta.remove();
    var msg = inner.querySelector('.urgency-banner__message');
    if (msg && message) msg.textContent = message;
    else if (!msg && message) {
      var p = document.createElement('p');
      p.className = 'urgency-banner__message';
      p.textContent = message;
      inner.insertBefore(p, inner.firstChild);
    }
  }

  function render(root, ms, cfg) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(total / 3600);
    total %= 3600;
    var m = Math.floor(total / 60);
    var s = total % 60;
    if (!cfg.showHours) m = h * 60 + m;

    var hn = root.querySelector('[data-h]');
    var mn = root.querySelector('[data-m]');
    var sn = root.querySelector('[data-s]');
    if (hn && cfg.showHours) hn.textContent = pad(h);
    if (mn) mn.textContent = pad(m);
    if (sn) sn.textContent = pad(s);
  }

  function stopTimer(root) {
    var tid = root.getAttribute('data-urgency-interval');
    if (tid) {
      window.clearInterval(parseInt(tid, 10));
      root.removeAttribute('data-urgency-interval');
    }
  }

  function startTimer(root, cfg) {
    if (cfg.mode === 'evergreen') return;

    var target;
    var isCampaign = cfg.mode === 'campaign';

    if (isCampaign) {
      target = parseEndAt(cfg.endAt);
      if (isNaN(target)) {
        // Bad date — hide the bar rather than show 00:00:00 forever
        hide(root);
        return;
      }
      if (target <= Date.now()) {
        showExpired(root, cfg.expiredMessage);
        return;
      }
    } else {
      var intervalHours = parseInt(cfg.intervalHours, 10) || 6;
      var anchorHour = parseInt(cfg.anchorHour, 10);
      if (isNaN(anchorHour)) anchorHour = 0;
      target = nextResetMs(intervalHours, anchorHour);
    }

    function tick() {
      var remaining = target - Date.now();
      if (remaining <= 0) {
        if (isCampaign) {
          stopTimer(root);
          showExpired(root, cfg.expiredMessage);
          return;
        }
        // daily_reset: roll into the next window without unmounting
        var ih = parseInt(cfg.intervalHours, 10) || 6;
        var ah = parseInt(cfg.anchorHour, 10);
        if (isNaN(ah)) ah = 0;
        target = nextResetMs(ih, ah);
        remaining = target - Date.now();
      }
      render(root, remaining, cfg);
    }

    tick();

    // Reveal the timer once it carries real values — server-renders with
    // [hidden] so JS-off visitors don't see a stuck 00:00:00.
    var timerEl = root.querySelector('[data-urgency-timer]');
    if (timerEl) timerEl.hidden = false;

    var id = window.setInterval(tick, 1000);
    root.setAttribute('data-urgency-interval', String(id));
  }

  function isDismissed(root) {
    var section = root.closest('.urgency-banner-section');
    return section && section.style.display === 'none';
  }

  function init(root) {
    if (!root || root.getAttribute('data-urgency-init') === 'true') return;
    root.setAttribute('data-urgency-init', 'true');

    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;

    var cfg = parseConfig(sectionId);
    if (!cfg) return;

    // Per-bar AbortController so the dismiss click handler is removed
    // deterministically when Theme Editor swaps in new section markup.
    // Matches the pattern used in announcement-bar; the section:unload
    // handler (below) calls .abort() before Shopify replaces the DOM.
    var controller = new AbortController();
    root._serenUrgencyController = controller;

    if (cfg.dismissable) {
      try {
        if (sessionStorage.getItem(cfg.dismissKey) === '1') {
          hide(root);
          return;
        }
      } catch (e) { /* storage may be disabled; proceed */ }

      var btn = root.querySelector('[data-urgency-dismiss]');
      if (btn) {
        btn.hidden = false; // Reveal once JS has wired the click handler
        btn.addEventListener('click', function () {
          try { sessionStorage.setItem(cfg.dismissKey, '1'); } catch (err) { /* ignore */ }
          hide(root);
        }, { signal: controller.signal });
      }
    }

    startTimer(root, cfg);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-urgency-banner]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme Editor: clean up the OLD section's interval AND abort its dismiss
  // listener before Shopify swaps in the new DOM. Without this, the old
  // setInterval kept ticking against a detached root after every editor save.
  document.addEventListener('shopify:section:unload', function (ev) {
    if (!ev.target) return;
    var bar = ev.target.querySelector('[data-urgency-banner]');
    if (!bar) return;
    stopTimer(bar);
    if (bar._serenUrgencyController) bar._serenUrgencyController.abort();
  });

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target) initAll(ev.target);
  });

  // Pause the tick when the tab is hidden; resume on show. Module-level so
  // repeated section loads don't accumulate listeners.
  document.addEventListener('visibilitychange', function () {
    var banner = document.querySelector('[data-urgency-banner]');
    if (!banner || isDismissed(banner)) return;

    if (document.hidden) {
      stopTimer(banner);
    } else if (!banner.getAttribute('data-urgency-interval')) {
      var cfg = parseConfig(banner.getAttribute('data-section-id'));
      if (cfg) startTimer(banner, cfg);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
